import React from 'react'

/*eslint-disable*/

export function MainLogoVertical({ props }) {
    return (
        <svg
            width={100}
            height={75}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M5.28521 60.0911C6.5275 60.0911 7.54191 59.775 8.32109 59.1429C9.10027 58.5107 9.48986 57.7389 9.48986 56.82C9.48986 56.0261 9.24729 55.416 8.76214 54.9897C8.27698 54.5633 7.57131 54.2105 6.65246 53.9311L4.03558 53.0858C3.36666 52.8873 3.02852 52.5565 3.02852 52.0934C3.02852 51.7774 3.18289 51.5054 3.49897 51.2849C3.81506 51.0643 4.21935 50.9541 4.7192 50.9541C5.29992 50.9541 5.82182 51.0864 6.28492 51.351C6.74802 51.6156 7.09351 51.9611 7.31403 52.3948L9.23259 51.8362C8.9312 51.0643 8.37254 50.4248 7.55661 49.9103C6.74067 49.3957 5.78507 49.1384 4.6898 49.1384C3.60924 49.1384 2.70509 49.4325 1.98471 50.0205C1.26433 50.6086 0.904147 51.3216 0.911497 52.1523C0.904147 52.8065 1.11732 53.3578 1.55102 53.8135C1.98471 54.2693 2.56542 54.6148 3.3005 54.8426L5.99089 55.688C6.49809 55.8423 6.85828 56.0261 7.07145 56.2319C7.28463 56.4378 7.38754 56.6803 7.38754 56.9597C7.38754 57.3199 7.20377 57.6286 6.82888 57.8932C6.45399 58.1578 5.96884 58.2902 5.37342 58.2902C4.6457 58.2902 4.01353 58.1064 3.48427 57.7389C2.95502 57.3713 2.58013 56.9009 2.3596 56.3201L0.382241 56.9156C0.705675 57.8124 1.29374 58.5695 2.14643 59.187C2.99912 59.8044 4.03558 60.1132 5.24846 60.1132L5.28521 60.0911ZM15.1647 58.0255C14.8853 58.1652 14.584 58.2387 14.2605 58.2387C13.6357 58.2387 13.327 57.9153 13.327 57.2758V54.0047H15.5543V52.2625H13.327V49.7927H11.3276V52.2625H10.0485V54.0047H11.3276V57.2758C11.3276 58.1284 11.5407 58.7974 11.9671 59.2752C12.3934 59.753 13.0256 59.9955 13.8709 59.9955C14.4516 59.9955 15.0471 59.8779 15.6498 59.6354L15.1647 58.0255ZM19.95 60.0911C20.9938 60.0911 21.8098 59.7089 22.3978 58.9444V59.8779H24.4046V52.2625H22.3978V53.1814C21.8098 52.4242 20.9938 52.0493 19.95 52.0493C18.8842 52.0493 17.9874 52.4316 17.267 53.1961C16.5466 53.9605 16.1864 54.9235 16.1864 56.0776C16.1864 57.2169 16.5466 58.1725 17.267 58.9444C17.9874 59.7162 18.8768 60.0985 19.9427 60.0985L19.95 60.0911ZM20.2882 58.3196C19.6633 58.3196 19.1488 58.1064 18.7445 57.6874C18.3402 57.2684 18.1417 56.7244 18.1417 56.0629C18.1417 55.4087 18.3402 54.872 18.7445 54.4531C19.1488 54.0341 19.6633 53.8282 20.2882 53.8282C20.8983 53.8282 21.4128 54.0414 21.8318 54.4604C22.2508 54.8794 22.4566 55.4087 22.4566 56.0482C22.4566 56.7024 22.2508 57.239 21.8318 57.6653C21.4128 58.0917 20.8983 58.3049 20.2882 58.3049V58.3196ZM28.3373 53.3872V52.2625H26.3526V59.8779H28.3373V56.5627C28.3373 55.563 28.5504 54.8573 28.9694 54.4457C29.3884 54.0341 30.0133 53.8944 30.8439 54.0267V52.1596C29.6678 51.9979 28.8298 52.4095 28.3299 53.3945L28.3373 53.3872ZM36.8054 58.0255C36.526 58.1652 36.2247 58.2387 35.9012 58.2387C35.2764 58.2387 34.9677 57.9153 34.9677 57.2758V54.0047H37.195V52.2625H34.9677V49.7927H32.9683V52.2625H31.6892V54.0047H32.9683V57.2758C32.9683 58.1284 33.1814 58.7974 33.6078 59.2752C34.0341 59.753 34.6663 59.9955 35.5116 59.9955C36.0924 59.9955 36.6878 59.8779 37.2905 59.6354L36.8054 58.0255ZM43.9871 52.2625V56.0114C43.9871 56.695 43.818 57.239 43.4872 57.6433C43.1565 58.0476 42.7081 58.2461 42.142 58.2461C41.6128 58.2461 41.2085 58.077 40.9292 57.7389C40.6498 57.4007 40.5102 56.9376 40.5102 56.3422V52.2772H38.5255V56.7171C38.5255 57.7683 38.7827 58.5989 39.2899 59.2017C39.7971 59.8044 40.5469 60.1058 41.5319 60.1058C42.5684 60.1058 43.3843 59.7162 43.9797 58.9297V59.8926H45.9718V52.2772L43.9871 52.2625ZM52.389 52.0493C51.3452 52.0493 50.5219 52.4242 49.9192 53.1814V52.2625H47.9345V63.0388H49.9192V58.9444C50.5293 59.7089 51.3526 60.0911 52.389 60.0911C53.4402 60.0911 54.3297 59.7089 55.05 58.937C55.7704 58.1652 56.1306 57.2096 56.1306 56.0702C56.1306 54.9161 55.7704 53.9605 55.05 53.1961C54.3297 52.4316 53.4402 52.0493 52.3743 52.0493H52.389ZM52.0289 58.3122C51.4187 58.3122 50.9042 58.099 50.4852 57.6727C50.0662 57.2463 49.8604 56.7097 49.8604 56.0555C49.8604 55.416 50.0662 54.8867 50.4852 54.4678C50.9042 54.0488 51.4187 53.8356 52.0289 53.8356C52.6537 53.8356 53.1682 54.0414 53.5725 54.4604C53.9768 54.8794 54.1753 55.416 54.1753 56.0702C54.1753 56.7318 53.9768 57.2758 53.5725 57.6947C53.1682 58.1137 52.6537 58.3269 52.0289 58.3269V58.3122ZM68.5387 54.3501C69.4135 53.8797 69.8472 53.1446 69.8472 52.1523C69.8398 51.3216 69.5164 50.6453 68.8769 50.1234C68.2373 49.6015 67.3993 49.3443 66.3629 49.3443H61.335V59.8853H66.6496C67.7595 59.8853 68.6343 59.6133 69.2738 59.0767C69.9133 58.5401 70.2294 57.8124 70.2294 56.9009C70.2294 56.3201 70.0824 55.8129 69.781 55.3719C69.4796 54.9309 69.0606 54.5927 68.524 54.3501H68.5387ZM66.3408 51.1158C66.7745 51.1084 67.1274 51.2261 67.3993 51.4686C67.6713 51.7112 67.8036 52.0199 67.8036 52.3948C67.811 52.7697 67.6787 53.0858 67.414 53.3431C67.1494 53.6004 66.8039 53.7253 66.3849 53.7253H63.3491V51.1231L66.3408 51.1158ZM66.6275 58.0917H63.3491V55.3572H66.6422C67.1127 55.3572 67.4876 55.4822 67.7669 55.7394C68.0462 55.9967 68.1859 56.3201 68.1859 56.7097C68.1859 57.114 68.0462 57.4448 67.7669 57.7021C67.4876 57.9594 67.1127 58.0917 66.6422 58.0917H66.6275ZM75.0662 60.0911C76.11 60.0911 76.926 59.7089 77.514 58.9444V59.8779H79.5208V52.2625H77.514V53.1814C76.926 52.4242 76.11 52.0493 75.0662 52.0493C74.0003 52.0493 73.1036 52.4316 72.3832 53.1961C71.6628 53.9605 71.3026 54.9235 71.3026 56.0776C71.3026 57.2169 71.6628 58.1725 72.3832 58.9444C73.1036 59.7162 73.993 60.0985 75.0589 60.0985L75.0662 60.0911ZM75.4043 58.3196C74.7795 58.3196 74.265 58.1064 73.8607 57.6874C73.4564 57.2684 73.2579 56.7244 73.2579 56.0629C73.2579 55.4087 73.4564 54.872 73.8607 54.4531C74.265 54.0341 74.7795 53.8282 75.4043 53.8282C76.0145 53.8282 76.529 54.0414 76.948 54.4604C77.367 54.8794 77.5728 55.4087 77.5728 56.0482C77.5728 56.7024 77.367 57.239 76.948 57.6653C76.529 58.0917 76.0145 58.3049 75.4043 58.3049V58.3196ZM84.4679 60.0911C85.4308 60.0911 86.2174 59.8559 86.8348 59.3854C87.4523 58.915 87.761 58.3196 87.761 57.5992C87.761 56.9744 87.5773 56.5113 87.2024 56.2025C86.8275 55.8938 86.2982 55.6365 85.6146 55.4381L83.7181 54.8941C83.2991 54.7691 83.0859 54.5707 83.0859 54.2913C83.0859 54.1076 83.1888 53.9458 83.402 53.8062C83.6152 53.6665 83.8725 53.6004 84.1738 53.6004C84.9236 53.6004 85.4676 53.8944 85.7984 54.4898L87.5626 53.9752C87.32 53.3945 86.8936 52.9314 86.2909 52.5786C85.6881 52.2258 84.9824 52.0493 84.1812 52.0493C83.3359 52.0493 82.6155 52.2699 82.0201 52.7183C81.4246 53.1667 81.1233 53.7033 81.1233 54.3354C81.1233 55.3278 81.7481 56.0041 83.0051 56.3643L84.9457 56.9376C85.5117 57.1067 85.791 57.3566 85.791 57.6874C85.791 57.9079 85.6734 58.0917 85.4382 58.2461C85.2029 58.4004 84.9016 58.4739 84.5267 58.4739C84.0342 58.4739 83.6152 58.3563 83.2623 58.1211C82.9095 57.8859 82.6669 57.5845 82.5346 57.2096L80.741 57.7315C80.9395 58.371 81.3805 58.9223 82.0642 59.3854C82.7478 59.8485 83.5417 60.0838 84.4458 60.0838L84.4679 60.0911ZM92.8625 60.0911C93.7813 60.0911 94.5605 59.8706 95.2 59.4369C95.8395 59.0032 96.2806 58.496 96.5305 57.9226L94.7369 57.3934C94.3841 58.0623 93.7666 58.4004 92.8845 58.4004C92.2229 58.4004 91.7084 58.2461 91.3335 57.93C90.9586 57.6139 90.7381 57.1949 90.6719 56.673H96.5893C96.6187 56.5113 96.6334 56.276 96.6334 55.9673C96.6334 54.8426 96.2806 53.9091 95.5749 53.1667C94.8692 52.4242 93.9063 52.0567 92.6934 52.0567C91.5099 52.0567 90.547 52.4389 89.8119 53.2034C89.0768 53.9679 88.7093 54.9309 88.7093 56.0849C88.7093 57.2905 89.0915 58.2608 89.856 58.9958C90.6205 59.7309 91.6128 60.0985 92.8404 60.0985L92.8625 60.0911ZM90.6572 55.4307C90.716 54.9676 90.9292 54.5707 91.2967 54.2399C91.6643 53.9091 92.12 53.74 92.6713 53.74C93.2447 53.74 93.7078 53.9017 94.068 54.2252C94.4282 54.5486 94.634 54.9529 94.6855 55.4307H90.6572Z" fill="#263238" />
            <path fillRule="evenodd" clipRule="evenodd" d="M21.251 20.8335C21.251 23.9514 23.76 26.4605 28.7782 31.4786L31.4394 34.1399L31.4395 34.1399C36.4576 39.158 38.9667 41.6671 42.0845 41.6671C44.3001 41.6671 46.2082 40.4002 48.9276 37.8663L48.9272 37.8658L58.0802 28.7128H51.608V25.8901H60.0761H60.6851C62.1737 24.0493 62.9181 22.5317 62.9181 20.8335C62.9181 17.7157 60.409 15.2066 55.3909 10.1885L52.7296 7.5272C51.4254 6.22305 50.2908 5.08837 49.2708 4.12315V6.10473V6.93146L49.2708 15.3996H46.4481V8.92743L37.2951 18.0804L35.2992 16.0845L44.4522 6.93146H37.98V4.10876H46.4481H49.2556C46.3593 1.36959 44.3881 0 42.0845 0C38.9667 0 36.4576 2.50907 31.4395 7.5272L28.7782 10.1885C23.76 15.2066 21.251 17.7157 21.251 20.8335Z" fill="url(#paint0_linear_1312_8290)" />
            <path d="M32.9605 65.7949H30.7112V71.0654H31.0934V69.0623H32.9385C33.464 69.0623 33.8794 68.9006 34.1807 68.5735C34.4821 68.2464 34.6328 67.8678 34.6328 67.4378C34.6328 67.0115 34.4821 66.6329 34.1807 66.2984C33.8794 65.964 33.4714 65.7986 32.9605 65.7986V65.7949ZM32.9311 68.7132H31.0934V66.1551H32.9532C33.3391 66.1551 33.6552 66.2837 33.8977 66.5373C34.1403 66.7909 34.2616 67.0923 34.2616 67.4378C34.2616 67.7833 34.1403 68.0847 33.9014 68.3383C33.6625 68.5919 33.3391 68.7205 32.9311 68.7205V68.7132ZM37.0114 71.1573C37.5664 71.1573 38.0295 70.9699 38.4007 70.595C38.7719 70.2201 38.9557 69.7533 38.9557 69.1983C38.9557 68.6433 38.7682 68.1802 38.397 67.809C38.0258 67.4378 37.5627 67.254 37.0077 67.254C36.4454 67.254 35.9749 67.4415 35.6001 67.8127C35.2252 68.1839 35.0377 68.647 35.0377 69.202C35.0377 69.757 35.2252 70.2238 35.6001 70.5987C35.9749 70.9735 36.4417 71.161 37.0041 71.161L37.0114 71.1573ZM37.0041 70.8118C36.552 70.8118 36.1734 70.6611 35.8684 70.3561C35.5633 70.051 35.4089 69.6688 35.4089 69.213C35.4089 68.7573 35.5633 68.375 35.8684 68.0663C36.1734 67.7576 36.552 67.6032 37.0041 67.6032C37.4488 67.6032 37.8237 67.7576 38.1287 68.0663C38.4338 68.375 38.5845 68.7573 38.5845 69.213C38.5845 69.6688 38.4338 70.051 38.1287 70.3561C37.8237 70.6611 37.4488 70.8155 37.0041 70.8155V70.8118ZM44.2709 67.3386L43.1867 70.5766L42.1318 67.3386H41.7937L40.7389 70.5766L39.6546 67.3386H39.265L40.5441 71.0654H40.9263L41.9664 67.9413L42.9992 71.0654H43.3815L44.6605 67.3386H44.2709ZM46.9509 71.1573C47.3883 71.1573 47.7521 71.0544 48.0425 70.8523C48.3328 70.6501 48.5534 70.3928 48.7041 70.0804L48.3475 69.9738C48.241 70.2091 48.0682 70.4075 47.8256 70.5693C47.5831 70.731 47.2927 70.8118 46.9582 70.8118C46.5062 70.8118 46.1386 70.6758 45.8556 70.4039C45.5726 70.1319 45.4219 69.7754 45.4036 69.3306H48.7298C48.7335 69.2682 48.7371 69.191 48.7371 69.0991C48.7371 68.5662 48.5717 68.1251 48.2446 67.776C47.9175 67.4268 47.4691 67.2504 46.8994 67.2504C46.3481 67.2504 45.8961 67.4378 45.5469 67.809C45.1977 68.1802 45.0213 68.6433 45.0213 69.1983C45.0213 69.7901 45.2014 70.2642 45.5653 70.6207C45.9291 70.9772 46.3922 71.1573 46.9582 71.1573H46.9509ZM45.3999 68.9962C45.4256 68.6029 45.5763 68.2721 45.8556 68.0002C46.135 67.7282 46.4804 67.5922 46.8958 67.5922C47.3331 67.5922 47.6786 67.7208 47.9359 67.9744C48.1932 68.228 48.3365 68.5662 48.3659 68.9888L45.3999 68.9962ZM50.0756 68.0332V67.3386H49.7081V71.0654H50.0756V69.2571C50.0756 68.658 50.2006 68.228 50.4505 67.9634C50.7004 67.6988 51.0386 67.5922 51.4649 67.64V67.2945C51.1304 67.2504 50.8438 67.2945 50.6049 67.4305C50.366 67.5665 50.1895 67.7686 50.0756 68.0369V68.0332ZM53.7075 71.1573C54.1449 71.1573 54.5087 71.0544 54.7991 70.8523C55.0895 70.6501 55.31 70.3928 55.4607 70.0804L55.1042 69.9738C54.9976 70.2091 54.8248 70.4075 54.5822 70.5693C54.3397 70.731 54.0493 70.8118 53.7149 70.8118C53.2628 70.8118 52.8952 70.6758 52.6122 70.4039C52.3292 70.1319 52.1785 69.7754 52.1602 69.3306H55.4864C55.4901 69.2682 55.4937 69.191 55.4937 69.0991C55.4937 68.5662 55.3284 68.1251 55.0012 67.776C54.6741 67.4268 54.2257 67.2504 53.6561 67.2504C53.1047 67.2504 52.6527 67.4378 52.3035 67.809C51.9543 68.1802 51.7779 68.6433 51.7779 69.1983C51.7779 69.7901 51.958 70.2642 52.3219 70.6207C52.6857 70.9772 53.1488 71.1573 53.7149 71.1573H53.7075ZM52.1565 68.9962C52.1822 68.6029 52.3329 68.2721 52.6122 68.0002C52.8916 67.7282 53.2371 67.5922 53.6524 67.5922C54.0897 67.5922 54.4352 67.7208 54.6925 67.9744C54.9498 68.228 55.0931 68.5662 55.1225 68.9888L52.1565 68.9962ZM59.7321 65.5707V68.1214C59.5704 67.8531 59.3498 67.64 59.0742 67.4856C58.7985 67.3312 58.4788 67.254 58.1186 67.254C57.571 67.254 57.1152 67.4415 56.755 67.8127C56.3948 68.1839 56.2147 68.647 56.2147 69.202C56.2147 69.757 56.3948 70.2238 56.755 70.5987C57.1152 70.9735 57.5673 71.161 58.1149 71.161C58.4788 71.161 58.7985 71.0838 59.0779 70.9294C59.3572 70.7751 59.574 70.5582 59.7284 70.2826V71.0728H60.096V65.5781L59.7321 65.5707ZM58.1553 70.8229C57.6996 70.8229 57.3247 70.6722 57.027 70.3671C56.7293 70.062 56.5823 69.6798 56.5823 69.2167C56.5823 68.7536 56.7293 68.3714 57.0233 68.0663C57.3174 67.7613 57.6959 67.6069 58.1553 67.6069C58.5927 67.6069 58.9639 67.7613 59.2727 68.0737C59.5814 68.3861 59.7358 68.7683 59.7358 69.2204C59.7358 69.6725 59.5814 70.0547 59.2727 70.3671C58.9639 70.6795 58.5927 70.8339 58.1553 70.8339V70.8229ZM65.3236 67.2504C64.9634 67.2504 64.6437 67.3276 64.368 67.4819C64.0923 67.6363 63.8718 67.8495 63.7101 68.1214V65.5707H63.3426V71.0654H63.7101V70.2752C63.8681 70.5509 64.085 70.7677 64.3643 70.9221C64.6437 71.0765 64.9634 71.1536 65.3236 71.1536C65.8712 71.1536 66.327 70.9662 66.6872 70.5913C67.0474 70.2164 67.2275 69.7496 67.2275 69.1947C67.2275 68.6397 67.0474 68.1766 66.6835 67.8054C66.3196 67.4341 65.8639 67.2504 65.3162 67.2504H65.3236ZM65.2795 70.8155C64.8421 70.8155 64.4709 70.6611 64.1622 70.3487C63.8534 70.0363 63.6991 69.6541 63.6991 69.202C63.6991 68.7499 63.8534 68.3677 64.1622 68.0553C64.4709 67.7429 64.8421 67.5885 65.2795 67.5885C65.7426 67.5885 66.1212 67.7429 66.4152 68.0479C66.7092 68.353 66.8562 68.7389 66.8562 69.202C66.8562 69.6651 66.7092 70.0473 66.4115 70.3524C66.1138 70.6575 65.7389 70.8118 65.2832 70.8118L65.2795 70.8155ZM70.8704 67.3386L69.4627 70.5766L67.9337 67.3386H67.5294L69.2679 70.9993L68.5439 72.6458H68.9445L71.271 67.3386H70.8704ZM74.0325 71.0654H74.4147V65.7949H74.0325V71.0654ZM79.6123 65.7949H75.1577V66.1514H77.1976V71.0654H77.5798V66.1514H79.6123V65.7949ZM84.6231 65.7949H82.3738V71.0654H82.756V69.0623H84.6011C85.1266 69.0623 85.542 68.9006 85.8433 68.5735C86.1447 68.2464 86.2954 67.8678 86.2954 67.4378C86.2954 67.0115 86.1447 66.6329 85.8433 66.2984C85.542 65.964 85.134 65.7986 84.6231 65.7986V65.7949ZM84.5937 68.7132H82.756V66.1551H84.6158C85.0017 66.1551 85.3178 66.2837 85.5603 66.5373C85.8029 66.7909 85.9242 67.0923 85.9242 67.4378C85.9242 67.7833 85.8029 68.0847 85.564 68.3383C85.3251 68.5919 85.0017 68.7205 84.5937 68.7205V68.7132ZM88.6115 71.1573C88.9717 71.1573 89.2915 71.0801 89.5708 70.9258C89.8501 70.7714 90.067 70.5546 90.2214 70.2789V71.0691H90.5889V67.3423H90.2214V68.1251C90.0596 67.8568 89.8391 67.6436 89.5635 67.4893C89.2878 67.3349 88.968 67.2577 88.6079 67.2577C88.0602 67.2577 87.6045 67.4452 87.2443 67.8164C86.8841 68.1876 86.704 68.6507 86.704 69.2057C86.704 69.7607 86.8841 70.2274 87.2443 70.6023C87.6045 70.9772 88.0565 71.1647 88.6042 71.1647L88.6115 71.1573ZM88.6446 70.8229C88.1889 70.8229 87.814 70.6722 87.5163 70.3671C87.2186 70.062 87.0715 69.6798 87.0715 69.2167C87.0715 68.7536 87.2186 68.3714 87.5126 68.0663C87.8066 67.7613 88.1852 67.6069 88.6446 67.6069C89.082 67.6069 89.4532 67.7613 89.7619 68.0737C90.0707 68.3861 90.225 68.7683 90.225 69.2204C90.225 69.6725 90.0707 70.0547 89.7619 70.3671C89.4532 70.6795 89.082 70.8339 88.6446 70.8339V70.8229ZM92.1883 68.0332V67.3386H91.8208V71.0654H92.1883V69.2571C92.1883 68.658 92.3133 68.228 92.5632 67.9634C92.8131 67.6988 93.1513 67.5922 93.5776 67.64V67.2945C93.2431 67.2504 92.9565 67.2945 92.7176 67.4305C92.4787 67.5665 92.3022 67.7686 92.1883 68.0369V68.0332ZM97.0257 71.0654H97.4852L95.6548 68.9594L97.2646 67.3386H96.7758L94.7654 69.349V65.5707H94.3978V71.0654H94.7654V69.8526L95.4049 69.213L97.0257 71.0654Z" fill="#263238" />
            <path fillRule="evenodd" clipRule="evenodd" d="M35.2812 21.1558C35.2812 24.2737 37.7903 26.7827 42.8084 31.8009L45.4697 34.4622L45.4697 34.4622C46.7734 35.7658 47.9077 36.9002 48.9274 37.8652L58.0803 28.7122H51.6082V25.8895H60.0763H62.899V27.8855V28.7122L62.899 37.1803H60.0763V30.7082L51.0416 39.7429C52.8899 41.2405 54.4115 41.9894 56.1148 41.9894C59.2327 41.9894 61.7417 39.4803 66.7599 34.4622L69.4211 31.8009C74.4393 26.7827 76.9483 24.2737 76.9483 21.1558C76.9483 18.0379 74.4393 15.5289 69.4211 10.5107L66.7599 7.84947C61.7417 2.83133 59.2327 0.322266 56.1148 0.322266C53.8991 0.322266 51.9908 1.58943 49.2709 4.12377V6.10419V6.93092L49.2709 15.399H46.4482L46.4482 8.92689L37.2952 18.0799L36.579 17.3637C35.7138 18.6716 35.2812 19.8612 35.2812 21.1558Z" fill="url(#paint1_linear_1312_8290)" />
            <defs>
                <linearGradient id="paint0_linear_1312_8290" x1="30.1088" y1="8.85808" x2="54.0597" y2="32.8095" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#83C805" />
                    <stop offset="1" stopColor="#ABDB06" />
                </linearGradient>
                <linearGradient id="paint1_linear_1312_8290" x1="44.1391" y1="9.18034" x2="68.09" y2="33.1317" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#83C805" />
                    <stop offset="1" stopColor="#ABDB06" />
                </linearGradient>
            </defs>
        </svg>
    )
}
export function MainLogo({ props }) {
    return (
        <svg
            width={213}
            height={43}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M70.938 23.416c1.9 0 3.452-.484 4.643-1.45 1.192-.967 1.788-2.148 1.788-3.553 0-1.214-.371-2.148-1.113-2.8-.742-.652-1.822-1.191-3.227-1.619l-4.002-1.293c-1.023-.303-1.54-.809-1.54-1.517 0-.484.236-.9.719-1.237.483-.337 1.102-.506 1.866-.506.888 0 1.687.202 2.395.607.708.405 1.237.933 1.574 1.597l2.934-.855c-.46-1.18-1.315-2.158-2.563-2.945-1.248-.787-2.71-1.18-4.385-1.18-1.652 0-3.035.449-4.137 1.348-1.102.9-1.653 1.99-1.641 3.26-.012 1.001.314 1.845.978 2.542.663.697 1.551 1.225 2.675 1.574l4.115 1.293c.776.236 1.327.517 1.653.831.326.315.483.686.483 1.113 0 .551-.28 1.024-.854 1.428-.573.405-1.315.607-2.226.607-1.113 0-2.08-.28-2.89-.843-.809-.562-1.382-1.282-1.72-2.17l-3.024.911c.495 1.372 1.394 2.53 2.698 3.474 1.305.944 2.89 1.417 4.745 1.417l.056-.034Zm15.11-3.16a3.054 3.054 0 0 1-1.383.327c-.955 0-1.427-.495-1.427-1.473v-5.003h3.406v-2.665h-3.406V7.665H80.18v3.777h-1.957v2.665h1.957v5.003c0 1.304.326 2.327.978 3.058.652.73 1.619 1.102 2.912 1.102.888 0 1.798-.18 2.72-.551l-.742-2.462Zm7.32 3.16c1.596 0 2.844-.585 3.743-1.754v1.428h3.069V11.442h-3.069v1.406c-.9-1.158-2.147-1.732-3.744-1.732-1.63 0-3.002.585-4.103 1.754-1.102 1.17-1.653 2.642-1.653 4.407 0 1.743.551 3.204 1.653 4.385 1.102 1.18 2.462 1.765 4.092 1.765l.011-.011Zm.517-2.71c-.956 0-1.743-.326-2.362-.966-.618-.641-.921-1.473-.921-2.485 0-1 .303-1.821.921-2.462.619-.641 1.406-.956 2.362-.956.933 0 1.72.326 2.36.967.641.64.956 1.45.956 2.428 0 1.001-.315 1.822-.955 2.474-.641.652-1.428.978-2.361.978v.022Zm12.31-7.543v-1.72h-3.035V23.09h3.035v-5.07c0-1.53.326-2.609.967-3.239.641-.63 1.597-.843 2.867-.64v-2.856c-1.799-.247-3.08.382-3.845 1.889l.011-.011Zm12.952 7.094a3.053 3.053 0 0 1-1.383.326c-.955 0-1.428-.495-1.428-1.473v-5.003h3.407v-2.665h-3.407V7.665h-3.058v3.777h-1.956v2.665h1.956v5.003c0 1.304.326 2.327.978 3.058.653.73 1.619 1.102 2.912 1.102a7.26 7.26 0 0 0 2.721-.551l-.742-2.462Zm10.984-8.815v5.734c0 1.046-.258 1.878-.764 2.496-.506.618-1.192.922-2.058.922-.809 0-1.428-.259-1.855-.776-.427-.517-.641-1.225-.641-2.136v-6.217h-3.035v6.79c0 1.608.393 2.879 1.169 3.8.776.922 1.923 1.383 3.429 1.383 1.585 0 2.833-.595 3.744-1.798v1.472h3.047V11.465l-3.036-.023Zm12.851-.326c-1.597 0-2.856.574-3.778 1.732v-1.406h-3.035v16.482h3.035v-6.262c.933 1.17 2.192 1.754 3.778 1.754 1.607 0 2.968-.585 4.07-1.765 1.101-1.18 1.652-2.642 1.652-4.385 0-1.765-.551-3.227-1.652-4.396-1.102-1.17-2.463-1.754-4.093-1.754h.023Zm-.551 9.58c-.933 0-1.72-.327-2.361-.979-.641-.652-.956-1.473-.956-2.473 0-.979.315-1.788.956-2.429.641-.64 1.428-.967 2.361-.967.955 0 1.742.315 2.361.956.618.64.922 1.461.922 2.462 0 1.012-.304 1.844-.922 2.485-.619.64-1.406.967-2.361.967v-.023Zm25.251-6.06c1.338-.72 2.001-1.845 2.001-3.362-.011-1.27-.506-2.305-1.484-3.103-.978-.799-2.26-1.192-3.845-1.192h-7.69v16.122h8.129c1.697 0 3.035-.416 4.013-1.237.978-.82 1.462-1.933 1.462-3.328 0-.888-.225-1.663-.686-2.338-.461-.675-1.102-1.192-1.922-1.563h.022Zm-3.362-4.948c.664-.01 1.203.17 1.619.54.416.371.619.843.619 1.417a1.893 1.893 0 0 1-.596 1.45c-.405.393-.933.585-1.574.585h-4.643V9.7l4.575-.012Zm.439 10.67h-5.014v-4.183h5.036c.72 0 1.293.192 1.721.585.427.394.64.888.64 1.484 0 .619-.213 1.125-.64 1.518-.428.393-1.001.596-1.721.596h-.022Zm12.907 3.058c1.596 0 2.844-.585 3.743-1.754v1.428h3.07V11.442h-3.07v1.406c-.899-1.158-2.147-1.732-3.743-1.732-1.631 0-3.002.585-4.104 1.754-1.102 1.17-1.653 2.642-1.653 4.407 0 1.743.551 3.204 1.653 4.385 1.102 1.18 2.462 1.765 4.092 1.765l.012-.011Zm.517-2.71c-.956 0-1.743-.326-2.361-.966-.619-.641-.922-1.473-.922-2.485 0-1 .303-1.821.922-2.462.618-.641 1.405-.956 2.361-.956.933 0 1.72.326 2.361.967.641.64.955 1.45.955 2.428 0 1.001-.314 1.822-.955 2.474-.641.652-1.428.978-2.361.978v.022Zm13.862 2.71c1.473 0 2.676-.36 3.62-1.08.945-.719 1.417-1.63 1.417-2.731 0-.956-.281-1.664-.855-2.137-.573-.472-1.382-.865-2.428-1.169l-2.901-.832c-.64-.19-.967-.494-.967-.922 0-.28.158-.528.484-.742.326-.213.719-.315 1.18-.315 1.147 0 1.979.45 2.485 1.36l2.698-.786c-.371-.888-1.023-1.597-1.945-2.136-.922-.54-2.001-.81-3.226-.81-1.293 0-2.395.338-3.306 1.023-.91.686-1.371 1.507-1.371 2.474 0 1.518.955 2.552 2.878 3.103l2.968.877c.866.258 1.293.64 1.293 1.146 0 .338-.18.619-.54.855-.36.236-.821.348-1.394.348-.753 0-1.394-.18-1.934-.54-.539-.359-.91-.82-1.113-1.393l-2.743.798c.304.978.978 1.821 2.024 2.53 1.045.708 2.26 1.068 3.642 1.068l.034.01Zm12.839 0c1.406 0 2.597-.337 3.576-1 .978-.664 1.652-1.44 2.034-2.317l-2.743-.81c-.539 1.024-1.484 1.541-2.833 1.541-1.012 0-1.799-.236-2.372-.72-.574-.483-.911-1.124-1.012-1.922h9.05c.045-.247.068-.607.068-1.08 0-1.72-.54-3.147-1.619-4.283-1.079-1.135-2.552-1.697-4.407-1.697-1.81 0-3.283.584-4.407 1.753-1.125 1.17-1.687 2.643-1.687 4.408 0 1.843.585 3.327 1.754 4.452 1.169 1.124 2.687 1.686 4.565 1.686l.033-.011Zm-3.372-7.128c.089-.708.416-1.315.978-1.821s1.259-.765 2.102-.765c.877 0 1.585.248 2.136.742a2.81 2.81 0 0 1 .945 1.844h-6.161Z"
                fill="#263238"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 20.937c0 3.04 2.446 5.485 7.337 10.377l2.594 2.594c4.892 4.891 7.338 7.337 10.377 7.337 2.16 0 4.02-1.235 6.67-3.704l8.922-8.922h-6.31v-2.752h8.848c1.452-1.795 2.178-3.274 2.178-4.93 0-3.039-2.446-5.485-7.338-10.376l-2.594-2.594c-1.271-1.272-2.377-2.378-3.371-3.319V15.641H24.56V9.332l-8.922 8.922-1.945-1.945 8.922-8.922h-6.31V4.635H27.3C24.475 1.965 22.554.63 20.308.63c-3.04 0-5.485 2.446-10.377 7.338L7.337 10.56C2.446 15.452 0 17.898 0 20.937Z"
                fill="url(#a)"
            />
            <path
                d="M113.267 30.318h-3.44v8.06h.584v-3.063h2.822c.804 0 1.439-.247 1.9-.747.461-.5.692-1.08.692-1.737 0-.653-.231-1.232-.692-1.743-.461-.512-1.085-.765-1.866-.765v-.005Zm-.045 4.463h-2.811V30.87h2.845c.59 0 1.073.197 1.444.584.371.388.557.85.557 1.378 0 .528-.186.989-.551 1.377-.365.388-.86.584-1.484.584v-.01Zm6.241 3.738c.849 0 1.557-.286 2.125-.86.567-.573.848-1.287.848-2.136 0-.849-.286-1.557-.854-2.125-.568-.567-1.276-.849-2.125-.849-.86 0-1.58.287-2.153.855-.573.568-.86 1.276-.86 2.125s.287 1.563.86 2.136c.573.573 1.287.86 2.147.86l.012-.006Zm-.012-.528c-.691 0-1.27-.23-1.737-.697-.466-.467-.702-1.051-.702-1.748 0-.697.236-1.282.702-1.754.467-.472 1.046-.708 1.737-.708.681 0 1.254.236 1.721.708.466.472.697 1.057.697 1.754 0 .697-.231 1.281-.697 1.748a2.342 2.342 0 0 1-1.721.703v-.006Zm11.115-5.312-1.658 4.952-1.614-4.952h-.517l-1.613 4.952-1.659-4.952h-.595l1.956 5.7h.584l1.591-4.778 1.58 4.778h.584l1.957-5.7h-.596Zm4.099 5.84c.669 0 1.225-.157 1.669-.466.444-.31.782-.703 1.012-1.18l-.545-.164c-.163.36-.427.664-.798.911-.371.247-.815.371-1.327.371-.691 0-1.254-.208-1.686-.624-.433-.416-.664-.961-.692-1.641h5.088c.005-.096.011-.214.011-.355 0-.815-.253-1.49-.753-2.023-.501-.534-1.187-.804-2.058-.804-.843 0-1.535.287-2.069.854-.534.568-.803 1.276-.803 2.125 0 .905.275 1.63.832 2.176.556.545 1.264.82 2.13.82h-.011Zm-2.372-3.305a2.252 2.252 0 0 1 .697-1.523c.427-.416.955-.624 1.59-.624.669 0 1.198.196 1.591.584.394.388.613.905.658 1.552l-4.536.011Zm7.151-1.473V32.68h-.562v5.7h.562v-2.766c0-.916.191-1.574.573-1.978.383-.405.9-.568 1.552-.495v-.529c-.512-.067-.95 0-1.316.208a1.874 1.874 0 0 0-.809.928v-.006Zm5.555 4.778c.669 0 1.225-.157 1.669-.466.444-.31.782-.703 1.012-1.18l-.545-.164c-.163.36-.427.664-.798.911-.371.247-.815.371-1.327.371-.691 0-1.254-.208-1.686-.624-.433-.416-.664-.961-.692-1.641h5.088c.005-.096.011-.214.011-.355 0-.815-.253-1.49-.753-2.023-.501-.534-1.187-.804-2.058-.804-.843 0-1.535.287-2.069.854-.534.568-.803 1.276-.803 2.125 0 .905.275 1.63.832 2.176.556.545 1.264.82 2.13.82h-.011Zm-2.372-3.305a2.252 2.252 0 0 1 .697-1.523c.427-.416.955-.624 1.59-.624.669 0 1.198.196 1.591.584.394.388.613.905.658 1.552l-4.536.011Zm11.586-5.24v3.902a2.689 2.689 0 0 0-1.006-.972c-.422-.236-.911-.355-1.462-.355-.837 0-1.534.287-2.085.855-.551.568-.826 1.276-.826 2.125s.275 1.563.826 2.136c.551.573 1.242.86 2.08.86.556 0 1.045-.118 1.473-.354.427-.236.758-.568.995-.99v1.21h.562v-8.405l-.557-.011Zm-2.411 8.034c-.697 0-1.271-.23-1.726-.697-.455-.467-.68-1.051-.68-1.76 0-.708.225-1.293.674-1.76.45-.466 1.029-.702 1.732-.702.669 0 1.236.236 1.709.714.472.478.708 1.063.708 1.754 0 .691-.236 1.276-.708 1.754a2.31 2.31 0 0 1-1.709.714v-.017Zm10.963-5.464c-.551 0-1.04.118-1.461.354a2.672 2.672 0 0 0-1.007.978v-3.901h-.562v8.404h.562V37.17a2.57 2.57 0 0 0 1.001.99c.427.236.916.354 1.467.354.838 0 1.535-.287 2.086-.86.551-.574.826-1.288.826-2.136 0-.85-.275-1.557-.832-2.125-.556-.568-1.253-.85-2.091-.85h.011Zm-.067 5.453a2.31 2.31 0 0 1-1.709-.714c-.472-.478-.708-1.063-.708-1.754 0-.692.236-1.276.708-1.754a2.31 2.31 0 0 1 1.709-.714c.708 0 1.287.236 1.737.703.449.466.674 1.057.674 1.765s-.225 1.293-.68 1.76c-.455.466-1.029.702-1.726.702l-.005.006Zm8.551-5.318-2.153 4.952-2.339-4.952h-.618l2.659 5.599-1.108 2.518h.613l3.559-8.117h-.613Zm4.836 5.7h.585v-8.061h-.585v8.06Zm8.534-8.061h-6.813v.545h3.12v7.516h.585v-7.516h3.108v-.545Zm7.664 0h-3.44v8.06h.584v-3.063h2.822c.804 0 1.439-.247 1.9-.747.461-.5.692-1.08.692-1.737 0-.653-.231-1.232-.692-1.743-.461-.512-1.085-.765-1.866-.765v-.005Zm-.045 4.463h-2.811V30.87h2.845c.59 0 1.074.197 1.445.584.371.388.556.85.556 1.378 0 .528-.185.989-.551 1.377-.365.388-.86.584-1.484.584v-.01Zm6.145 3.738c.551 0 1.04-.118 1.467-.354.428-.236.759-.568.995-.99v1.21h.563v-5.7h-.563v1.197a2.689 2.689 0 0 0-1.006-.973c-.421-.236-.91-.354-1.461-.354-.838 0-1.535.287-2.086.855-.551.567-.826 1.276-.826 2.125 0 .848.275 1.562.826 2.136.551.573 1.242.86 2.08.86l.011-.012Zm.051-.511c-.697 0-1.271-.23-1.726-.697-.455-.467-.68-1.051-.68-1.76 0-.708.225-1.293.674-1.76.45-.466 1.029-.702 1.732-.702a2.31 2.31 0 0 1 1.709.714c.472.478.708 1.063.708 1.754 0 .691-.236 1.276-.708 1.754a2.31 2.31 0 0 1-1.709.714v-.017Zm5.42-4.267V32.68h-.562v5.7h.562v-2.766c0-.916.191-1.574.573-1.978.382-.405.9-.568 1.552-.495v-.529c-.512-.067-.95 0-1.316.208a1.874 1.874 0 0 0-.809.928v-.006Zm7.398 4.638h.703l-2.799-3.221 2.462-2.48h-.748l-3.075 3.076v-5.78h-.562v8.405h.562v-1.855l.978-.978 2.479 2.833Z"
                fill="#263238"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.676 21.25c0 3.04 2.446 5.485 7.337 10.377l2.594 2.594c1.271 1.27 2.377 2.376 3.37 3.317l8.923-8.922h-6.31v-2.752H40.598V36.87h-2.752v-6.308l-8.806 8.806c1.801 1.46 3.284 2.19 4.945 2.19 3.039 0 5.484-2.446 10.376-7.337l2.594-2.594c4.892-4.892 7.337-7.338 7.337-10.377 0-3.039-2.445-5.485-7.337-10.376L44.36 8.28C39.468 3.388 37.023.942 33.984.942c-2.16 0-4.02 1.236-6.671 3.706v10.991H24.56v-6.31l-8.922 8.923-.698-.698c-.844 1.275-1.265 2.434-1.265 3.696Z"
                fill="url(#b)"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1={8.634}
                    y1={9.264}
                    x2={31.981}
                    y2={32.611}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#83C805" />
                    <stop offset={1} stopColor="#ABDB06" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1={22.31}
                    y1={9.577}
                    x2={45.657}
                    y2={32.924}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#83C805" />
                    <stop offset={1} stopColor="#ABDB06" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export const MailIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m17.902 8.851-4.443 3.613c-.84.666-2.02.666-2.86 0l-4.48-3.613"
            stroke="#9B9C9F"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M16.909 21C19.95 21.008 22 18.51 22 15.438V8.57C22 5.499 19.95 3 16.909 3H7.09C4.05 3 2 5.499 2 8.57v6.868C2 18.51 4.05 21.008 7.091 21h9.818Z"
            stroke="#9B9C9F"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const LoginImage = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 372.61" {...props}>
    <defs>
      <style>
        {
          ".cls-1{fill:#ebebeb}.cls-2{fill:#fafafa}.cls-3{fill:#e0e0e0}.cls-4{opacity:.8}.cls-5{fill:#f5f5f5}.cls-6{fill:#f0f0f0}.cls-7{fill:#e6e6e6}.cls-8{fill:#263238}.cls-21,.cls-9{fill:#407bff}.cls-10,.cls-15,.cls-18,.cls-19,.cls-20,.cls-24{fill:#fff}.cls-10{opacity:.6}.cls-14{opacity:.3}.cls-12{fill:#ffb573}.cls-13,.cls-19{opacity:.2}.cls-18{opacity:.1}.cls-20{opacity:.9}.cls-21{opacity:.5}.cls-24{opacity:.7}"
        }
      </style>
    </defs>
    <title>{"study"}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Background_Complete" data-name="Background Complete">
        <path
          d="M0 327.45h500v.25H0zM394.36 338.9h50.9v.25h-50.9zM52.46 335.94h47.21v.25H52.46zM378.81 334.26H398v.25h-19.19zM317.14 340.89h14.08v.25h-14.08zM272.79 340.89h35.44v.25h-35.44zM195.22 336.66h56.99v.25h-56.99zM237 282.85H43.91a5.71 5.71 0 0 1-5.7-5.71V5.71A5.71 5.71 0 0 1 43.91 0H237a5.71 5.71 0 0 1 5.71 5.71v271.43a5.71 5.71 0 0 1-5.71 5.71ZM43.91.25a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V5.71A5.47 5.47 0 0 0 237 .25ZM453.31 282.85h-193.1a5.72 5.72 0 0 1-5.71-5.71V5.71A5.72 5.72 0 0 1 260.21 0h193.1A5.71 5.71 0 0 1 459 5.71v271.43a5.71 5.71 0 0 1-5.69 5.71ZM260.21.25a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V5.71a5.47 5.47 0 0 0-5.46-5.46Z"
          className="cls-1"
        />
        <path d="M288.57 30.71h101.8v296.73h-101.8z" className="cls-1" />
        <path d="M383.5 36.72v284.73h-88.06V36.72z" className="cls-2" />
        <path d="M183.72 30.71h101.8v296.73h-101.8z" className="cls-1" />
        <path d="M288.57 326.28h-3.05V31.88h3.05z" className="cls-3" />
        <path d="M278.65 36.71v284.73h-88.06V36.71z" className="cls-2" />
        <path
          d="M436.87 28.49H137.22a1.34 1.34 0 0 1-1.33-1.33 1.34 1.34 0 0 1 1.33-1.33h299.65a1.34 1.34 0 0 1 1.33 1.33 1.34 1.34 0 0 1-1.33 1.33ZM383.5 36.72v5.67h-88.06v-5.67z"
          className="cls-3"
        />
        <path
          d="M383.5 36.71v9.56h-88.06v-9.56zM278.65 36.71V57.6h-88.06V36.71z"
          className="cls-3"
        />
        <g className="cls-4">
          <path d="M375.24 19.6h28.2v304.19h-28.2z" className="cls-5" />
          <path d="M382.69 19.6H396v304.19h-13.31z" className="cls-6" />
          <path d="M390.37 19.6h28.2v304.19h-28.2z" className="cls-5" />
          <path d="M397.82 19.6h13.31v304.19h-13.31z" className="cls-6" />
          <path d="M404.47 19.6h28.2v304.19h-28.2z" className="cls-5" />
        </g>
        <g className="cls-4">
          <path d="M140.53 19.6h40.93v304.19h-40.93z" className="cls-5" />
          <path d="M151.33 19.6h19.32v304.19h-19.32z" className="cls-6" />
          <path d="M162.48 19.6h40.93v304.19h-40.93z" className="cls-5" />
          <path d="M173.28 19.6h19.32v304.19h-19.32z" className="cls-6" />
          <path d="M182.94 19.6h40.93v304.19h-40.93z" className="cls-5" />
        </g>
        <path d="M55.07 50.78h66.03v148.67H55.07z" className="cls-6" />
        <path d="M123.18 199.45h-2.08V50.78h2.08z" className="cls-7" />
        <path d="M115.1 56.78v136.67H61.07V56.78z" className="cls-2" />
        <path
          d="M125.26 273.12H57.48a5.64 5.64 0 0 1-5.63-5.62 5.64 5.64 0 0 1 5.63-5.62h67.78a5.64 5.64 0 0 1 5.62 5.62 5.64 5.64 0 0 1-5.62 5.62Z"
          className="cls-5"
        />
        <path
          d="M73.78 273.12H62.65L50 327.45h11.12l12.66-54.33zM95.98 273.12H84.86l-6.23 54.33h11.12l6.23-54.33zM108.96 273.12h11.12l12.66 54.33h-11.13l-12.65-54.33z"
          className="cls-7"
        />
      </g>
      <g id="Shadow">
        <ellipse
          id="_Path_"
          cx={250}
          cy={361.29}
          className="cls-5"
          data-name="&lt;Path&gt;"
          rx={193.89}
          ry={11.32}
        />
      </g>
      <g id="Character">
        <rect
          width={91.19}
          height={9.22}
          x={226.31}
          y={243.41}
          className="cls-8"
          rx={2.93}
        />
        <path
          d="M313.76 355.29h3.74l-4.3-102.66h-5.18l5.74 102.66z"
          className="cls-9"
        />
        <path
          d="M313.76 355.29h3.74l-4.3-102.66h-5.18l5.74 102.66z"
          className="cls-10"
        />
        <path
          d="M279.33 355.29h-3.74l4.3-102.66h5.18l-5.74 102.66z"
          className="cls-9"
        />
        <path
          d="M279.33 355.29h-3.74l4.3-102.66h5.18l-5.74 102.66z"
          className="cls-10"
        />
        <path
          d="M264.49 355.29h3.74l-4.31-102.66h-5.17l5.74 102.66z"
          className="cls-9"
        />
        <path
          d="M264.49 355.29h3.74l-4.31-102.66h-5.17l5.74 102.66z"
          className="cls-10"
        />
        <path
          d="M230.05 355.29h-3.74l4.31-102.66h5.17l-5.74 102.66z"
          className="cls-9"
        />
        <path
          d="M230.05 355.29h-3.74l4.31-102.66h5.17l-5.74 102.66z"
          className="cls-10"
        />
        <g
          style={{
            opacity: 0.3,
          }}
        >
          <path
            d="M313.2 252.62h-5.18l.24 4.37h5.12l-.18-4.37zM279.71 256.99h5.11l.25-4.37h-5.18l-.18 4.37zM258.75 252.62l.24 4.37h5.12l-.19-4.37h-5.17zM230.43 256.99h5.13l.24-4.37h-5.18l-.19 4.37z"
            className="cls-9"
          />
        </g>
        <path
          d="m262.08 340.2-8.46 4.5-13.34-18.01 8.47-4.5 13.33 18.01z"
          className="cls-12"
        />
        <path
          d="m250.56 341.92 8.84-6.14a.68.68 0 0 1 1 .13l5.29 6.69a1.71 1.71 0 0 1-.41 2.36c-3.11 2.08-4.51 2.81-8.58 5.23-2.51 1.48-8.51 5-12.2 6.61s-5.17-2.09-3.75-3.1c3.37-2.38 7.83-7.07 8.84-10.35a2.67 2.67 0 0 1 .97-1.43Z"
          className="cls-8"
        />
        <path
          d="m248.76 322.19-8.48 4.5 6.43 8.67 8.28-4.75-6.23-8.42z"
          className="cls-13"
        />
        <path
          d="M269.19 215.52s-65.74-2.05-66 25.42c-.32 39.48 37.15 91.32 37.15 91.32l14.66-9.75s-25.68-37.69-25.9-68.51c19.37-5.47 65-2 70.91-18.09 4.84-13.14 2.31-20.39 2.31-20.39Z"
          className="cls-9"
        />
        <path
          d="M269.19 215.52s-65.74-2.05-66 25.42c-.32 39.48 37.15 91.32 37.15 91.32l14.66-9.75s-25.68-37.69-25.9-68.51c19.37-5.47 65-2 70.91-18.09 4.84-13.14 2.31-20.39 2.31-20.39Z"
          className="cls-13"
        />
        <path
          d="m258.98 325.02-17.44 10.68-5.47-5.55 19.16-12.06 3.75 6.93z"
          className="cls-8"
        />
        <path
          d="M248.73 345.23a12.09 12.09 0 0 0 1.9-1.74.22.22 0 0 0-.17-.37c-.37 0-3.65 0-4.35 1.07a.83.83 0 0 0-.07.81 1.22 1.22 0 0 0 .92.84 2.62 2.62 0 0 0 1.77-.61Zm1.21-1.66c-1.21 1.26-2.28 1.94-2.9 1.83a.79.79 0 0 1-.58-.56.38.38 0 0 1 0-.4c.4-.56 2.17-.81 3.48-.87Z"
          className="cls-9"
        />
        <path
          d="M250.59 343.52a.19.19 0 0 0 .07-.08.2.2 0 0 0 0-.21c-.06-.1-1.46-2.49-2.78-2.7a1.13 1.13 0 0 0-1 .28.87.87 0 0 0-.28 1c.42 1 2.73 1.81 3.84 1.73a.15.15 0 0 0 .15-.02Zm-3.29-2.44a.69.69 0 0 1 .51-.11c.79.13 1.75 1.38 2.25 2.14-1.09-.1-2.73-.81-3-1.45-.05-.13-.08-.29.17-.51Z"
          className="cls-9"
        />
        <path
          d="m246.43 351.24-9.5-.45-1.56-22.43 9.5.45 1.56 22.43z"
          className="cls-12"
        />
        <path
          d="m236.71 349.17 10.75-.34a.69.69 0 0 1 .74.63l.8 8.54a1.71 1.71 0 0 1-1.63 1.76c-3.74.05-5.54-.11-10.27 0-2.91.09-8.63.52-12.62 0s-3.38-4.44-1.65-4.58c4.11-.33 9.62-3.17 12.26-5.38a2.63 2.63 0 0 1 1.62-.63Z"
          className="cls-8"
        />
        <path
          d="M233.37 350.94a12.35 12.35 0 0 0 2.54-.42.21.21 0 0 0 .16-.18.21.21 0 0 0-.1-.22c-.31-.21-3.08-2-4.23-1.48a.85.85 0 0 0-.5.65 1.23 1.23 0 0 0 .31 1.2 2.61 2.61 0 0 0 1.82.45Zm1.91-.73c-1.7.4-3 .39-3.42 0a.84.84 0 0 1-.19-.8.43.43 0 0 1 .24-.32c.62-.3 2.24.45 3.37 1.12Z"
          className="cls-9"
        />
        <path
          d="M235.86 350.53h.1a.21.21 0 0 0 .11-.19c0-.11.14-2.87-.86-3.77a1.11 1.11 0 0 0-1-.29.86.86 0 0 0-.79.71c-.19 1.05 1.3 3 2.27 3.54Zm-1.43-3.84a.63.63 0 0 1 .48.18c.6.53.72 2.11.73 3-.86-.68-1.86-2.17-1.73-2.86 0-.13.09-.28.41-.33Z"
          className="cls-9"
        />
        <path
          d="m244.88 328.81-9.51-.45.89 12.83 9.48-.01-.86-12.37z"
          className="cls-13"
        />
        <path
          d="M292.57 215.52s-68.78 6.5-66.28 27.21c3.62 29.86 5.4 94.22 5.4 94.22l17.53.69s7.43-58.05 3.59-88.63c17.8 0 61.38 1.28 65.35-9.45 3.51-9.47 2.26-24 2.26-24Z"
          className="cls-9"
        />
        <path
          d="m251.16 338.72-21.04-1.04-.76-9.16 23.08 1.59-1.28 8.61z"
          className="cls-8"
        />
        <path
          d="M277.31 154.86c-.13 1.68-.26 3.13-.45 4.68s-.39 3-.63 4.56c-.47 3-1.07 6-1.77 9.07a71.91 71.91 0 0 1-6.59 18.22 32.61 32.61 0 0 1-3.09 4.58 20.87 20.87 0 0 1-4.54 4.23 22.69 22.69 0 0 1-11.07 3.74 31.74 31.74 0 0 1-10.29-1 38.33 38.33 0 0 1-4.66-1.49c-.76-.29-1.5-.62-2.23-1s-1.41-.7-2.25-1.15l2.63-6.69 1.91.24 2 .2q2 .16 4 .18a28.1 28.1 0 0 0 7.21-.83 10.92 10.92 0 0 0 6.75-4.59 24.61 24.61 0 0 0 1.58-2.84 45.89 45.89 0 0 0 2.59-7.11c.76-2.53 1.37-5.19 1.92-7.88s1-5.43 1.45-8.19l.59-4.14c.18-1.35.38-2.81.51-4Z"
          className="cls-12"
        />
        <path
          d="M277.37 146.71c-7-6.8-15.7-2.78-19.16 9.94a118.15 118.15 0 0 0-4 20.88l22.27 4.6c4.05-12.13 8.09-28.46.89-35.42Z"
          className="cls-8"
        />
        <path
          d="M270.2 160.61c1.59-1.44 6.11 5 8.87 12.93-.78 3-1.67 5.89-2.58 8.6l-13.4-2.77c1.07-7.92 3.54-15.54 7.11-18.76Z"
          className="cls-14"
        />
        <path
          d="m230.86 189.58-5-1.91-.22 10.62s8.4 3.63 10.11-.54l-.6-2.65a8.61 8.61 0 0 0-4.29-5.52Z"
          className="cls-12"
        />
        <path
          d="m219.96 187.96-2.95 8.9 8.67 1.43.22-10.61-5.94.28z"
          className="cls-12"
        />
        <path
          d="M227.52 195a.56.56 0 0 1-.51-.31l-8.93-17.19a.57.57 0 1 1 1-.53l8.92 17.21a.58.58 0 0 1-.24.78.66.66 0 0 1-.24.04ZM276.54 139.9l10.68-3.05 13.72-.65a9.53 9.53 0 0 1 9.5 6.56c2.61 8 5 19.53 6.77 29.5 2 11.18 3 28 3.21 43.26h-51.23c-1.17-31.85-5.22-50.68-7-61.1a9.48 9.48 0 0 1 5.28-10.19Z"
          className="cls-8"
        />
        <path
          d="M317.21 172.26c-1.38-7.84-3.16-16.68-5.14-24-9.13-1.55-13.55 18.48-10.84 28.41s17.16 3.91 17.16 3.91c-.34-2.98-.74-5.79-1.18-8.32Z"
          className="cls-14"
        />
        <path
          d="M285.4 116.06c2.2 5.4.88 15.3-3.46 12.5s2.12-15.8 3.46-12.5Z"
          className="cls-8"
        />
        <path
          d="m283 119.51-4.15 6.33-5.64 8.63a8.84 8.84 0 0 1 1.74 2.56c1 2.08 1.89 3.63-2.48 6.61a2.9 2.9 0 0 0-1.31 2.86c.26 1.35 1.6 2.66 6.31 1.83a21.66 21.66 0 0 0 11.82-6.57c1.57-1.56 1.21-2.75-.3-4.37-4.32-4.6-5.6-11.95-5.99-17.88Z"
          className="cls-12"
        />
        <path
          d="m274.56 132.35 3.44-6.15c.07.15.15.33.24.51a15.56 15.56 0 0 1 .74 2.35c.63 2.74-1.49 6.64-3.82 8.5l-.27-.53a10.58 10.58 0 0 0-1.6-2.45 1.1 1.1 0 0 0-.14-.11Z"
          className="cls-13"
        />
        <path
          d="M253.79 112.05c-1.29 2.91 3.28 11.15 8.51 7.82s-6.23-12.98-8.51-7.82Z"
          className="cls-8"
        />
        <path
          d="M279 150.1a.29.29 0 0 1-.29-.24c-.38-2.48-2-4-3.83-5.86-2.32-2.28-4.95-4.86-5.81-9.9a.29.29 0 0 1 .23-.34.27.27 0 0 1 .33.24c.84 4.86 3.4 7.37 5.65 9.59 1.85 1.81 3.59 3.52 4 6.18a.29.29 0 0 1-.24.33Z"
          className="cls-15"
        />
        <path
          d="M281.13 109.12c2 9.06 3.56 14.27.33 20-4.88 8.67-17.08 7.49-21.72-.84-4.18-7.51-6.67-21.06 1.1-26.91a12.87 12.87 0 0 1 20.29 7.75Z"
          className="cls-12"
        />
        <path
          d="M283.82 115.34c-3.12 4.43-11.3-3.71-10.63-9.17-8.12 4.63-16.94 10.8-22.29 5.6-6.18-6-4.49-14.6 2.75-15.37-1.28 2.5 6 3.61 9.87-.26 6.55-6.48 16.9-5.12 16.71.13 4.99-1.98 10.44 9.34 3.59 19.07Z"
          className="cls-8"
        />
        <path
          d="M279.27 97.74c1.93-1.44.65-6.57-3.83-8.08 4.26.55 8.67 3.73 3.83 8.08Z"
          className="cls-8"
        />
        <path
          d="M286.71 114.94a8.48 8.48 0 0 1-1.9 5.71c-1.72 2-4.37.41-5-2.14-.55-2.29.16-5.84 2.42-6.94s4.36.79 4.48 3.37Z"
          className="cls-12"
        />
        <path
          d="M268.13 116.46c.24.74.06 1.47-.42 1.65s-1-.28-1.29-1-.06-1.47.42-1.64 1.05.26 1.29.99ZM259.93 119.47c.25.74.06 1.47-.42 1.65s-1.05-.28-1.29-1-.05-1.47.42-1.64 1.05.26 1.29.99Z"
          className="cls-8"
        />
        <path
          d="M262.74 119.08a25 25 0 0 1-.76 6.5c1.47.53 3.09-.73 3.09-.73Z"
          style={{
            fill: "#ed893e",
          }}
        />
        <path
          d="M267.13 128.88a6.61 6.61 0 0 0 3.91-3.45.23.23 0 0 0-.12-.3.23.23 0 0 0-.3.13 6.37 6.37 0 0 1-4.45 3.42.23.23 0 0 0-.18.27.23.23 0 0 0 .27.17 5.52 5.52 0 0 0 .87-.24ZM268.88 113.29a.44.44 0 0 0 .17-.16.44.44 0 0 0-.14-.62 4.34 4.34 0 0 0-4.07-.42.44.44 0 0 0-.22.6.46.46 0 0 0 .61.22 3.43 3.43 0 0 1 3.19.36.47.47 0 0 0 .46.02ZM258.31 114.73a.45.45 0 0 0-.63-.47 4.32 4.32 0 0 0-2.66 3.11.44.44 0 0 0 .37.52.45.45 0 0 0 .52-.37 3.45 3.45 0 0 1 2.09-2.42.46.46 0 0 0 .31-.37Z"
          className="cls-8"
        />
        <path
          d="M308.67 143.07c1 1.62 1.8 3.07 2.63 4.64s1.63 3.08 2.41 4.64c1.58 3.11 3 6.31 4.38 9.57s2.59 6.61 3.63 10.12a57 57 0 0 1 2.28 11.25 27.09 27.09 0 0 1-.23 6.71 14.88 14.88 0 0 1-1.32 4.21 12.69 12.69 0 0 1-3.06 3.94 13.53 13.53 0 0 1-3.86 2.34 17.59 17.59 0 0 1-3.67 1 25.41 25.41 0 0 1-6.41.17 38.44 38.44 0 0 1-5.66-.91 54.2 54.2 0 0 1-5.26-1.49 64.88 64.88 0 0 1-9.86-4.17l2.53-6.73c6.22 1.18 12.9 2.27 18.51 1.93a15.65 15.65 0 0 0 3.62-.63c1-.3 1.51-.74 1.47-.88s-.06-.05-.08-.1 0-.11 0-.63a14.66 14.66 0 0 0-.2-3.35 46.12 46.12 0 0 0-2.23-8.38c-1-2.89-2.21-5.82-3.52-8.73s-2.72-5.81-4.15-8.71q-1.08-2.16-2.23-4.31l-2.26-4.18Z"
          className="cls-12"
        />
        <path
          d="M304 136.36c-9.66-1.47-14.41 6.82-9.86 19.2a117.34 117.34 0 0 0 8.82 19.33l20.83-9.13c-3.79-12.25-9.91-27.89-19.79-29.4Z"
          className="cls-8"
        />
        <path
          d="m281.84 187.43-4.46 1.35 6.33 9s9.38-3.36 7.46-7.44l-2.36-1.34c-2.02-1.17-4.58-2.39-6.97-1.57Z"
          className="cls-12"
        />
        <path
          d="m273.43 194.97 4.47 4.47 5.81-1.67-6.33-8.99-3.95 6.19z"
          className="cls-12"
        />
        <ellipse
          cx={283.18}
          cy={116.06}
          className="cls-15"
          rx={1.44}
          ry={1.74}
        />
        <path
          d="m284.37 120.66-.83-.03-.51-4.01 1.58-.35-.24 4.39z"
          className="cls-15"
        />
        <path
          d="M290.11 196.24c-3 0-5.66-.44-7.27-1.9a5.77 5.77 0 0 1-1.75-4.51 46.27 46.27 0 0 1 1.91-12.16c1.39-5.45 2.49-9.76-.85-15.06-5.32-8.43-3.73-20.22 0-27.61 2.85-5.65 1.88-11.91 1.52-14.27-.05-.31-.09-.54-.11-.7a.29.29 0 0 1 .58-.06c0 .15.05.38.09.67.38 2.41 1.37 8.8-1.57 14.62-3.65 7.25-5.21 18.8 0 27 3.47 5.52 2.29 10.15.92 15.51a45.89 45.89 0 0 0-1.87 12 5.17 5.17 0 0 0 1.55 4.08c2.7 2.43 8.66 1.82 14.42 1.22 2.58-.26 5.25-.54 7.6-.54a.29.29 0 1 1 0 .58c-2.32 0-5 .27-7.54.54s-5.25.59-7.63.59Z"
          className="cls-15"
        />
        <rect
          width={12.58}
          height={2}
          x={305.24}
          y={194.11}
          className="cls-15"
          rx={0.6}
        />
      </g>
      <g id="Desk">
        <path
          d="M388.64 202.77H111.36a3.34 3.34 0 0 1-3.33-3.33 3.34 3.34 0 0 1 3.33-3.33h277.28a3.34 3.34 0 0 1 3.33 3.33 3.34 3.34 0 0 1-3.33 3.33Z"
          className="cls-9"
        />
        <path
          d="M388.64 202.77h-64.91a3.34 3.34 0 0 1-3.33-3.33 3.34 3.34 0 0 1 3.33-3.33h64.91a3.34 3.34 0 0 1 3.33 3.33 3.34 3.34 0 0 1-3.33 3.33Z"
          style={{
            opacity: 0.3,
            fill: "#263238",
          }}
        />
        <path
          d="M385.58 359.67h6.39l-7.35-156.9h-8.84l9.8 156.9z"
          className="cls-8"
        />
        <path
          d="M385.58 359.67h6.39l-7.35-156.9h-8.84l9.8 156.9z"
          className="cls-18"
        />
        <path
          d="M326.79 359.67h-6.39l7.35-156.9h8.84l-9.8 156.9z"
          className="cls-8"
        />
        <path
          d="M326.79 359.67h-6.39l7.35-156.9h8.84l-9.8 156.9z"
          className="cls-19"
        />
        <path
          d="M173.22 359.67h6.38l-7.35-156.9h-8.84l9.81 156.9z"
          className="cls-8"
        />
        <path
          d="M173.22 359.67h6.38l-7.35-156.9h-8.84l9.81 156.9z"
          className="cls-18"
        />
        <path
          d="M114.42 359.67h-6.39l7.35-156.9h8.84l-9.8 156.9z"
          className="cls-8"
        />
        <path
          d="M114.42 359.67h-6.39l7.35-156.9h8.84l-9.8 156.9z"
          className="cls-19"
        />
        <path d="M117.24 211.12h213.25v13.15H117.24z" className="cls-8" />
        <path d="M117.24 211.12h213.25v13.15H117.24z" className="cls-19" />
        <path
          d="M152.33 187.26a1.4 1.4 0 0 0-1.4 1.4v6.05a1.4 1.4 0 0 0 1.4 1.4h45.35a.46.46 0 0 0 .46-.45v-7.94a.47.47 0 0 0-.46-.46Z"
          className="cls-9"
        />
        <path
          d="M179.17 188.11h19v7.16h-19a.81.81 0 0 1-.81-.81v-5.55a.81.81 0 0 1 .81-.8Z"
          className="cls-20"
        />
        <rect
          width={48.61}
          height={8.85}
          x={128.84}
          y={187.26}
          className="cls-9"
          rx={1.4}
        />
        <rect
          width={48.61}
          height={8.85}
          x={128.84}
          y={187.26}
          className="cls-13"
          rx={1.4}
        />
        <rect
          width={8.09}
          height={8.85}
          x={146}
          y={187.26}
          className="cls-21"
          rx={0.57}
        />
        <rect
          width={8.08}
          height={8.85}
          x={156.04}
          y={187.26}
          className="cls-21"
          rx={0.57}
        />
        <path
          d="M144.13 176.37a1.4 1.4 0 0 0-1.4 1.4v8.09a1.4 1.4 0 0 0 1.4 1.4h49.13a.45.45 0 0 0 .45-.45v-10a.46.46 0 0 0-.45-.46Z"
          className="cls-9"
        />
        <path
          d="M171 177.21h22.74v9.21H171a.81.81 0 0 1-.81-.81V178a.81.81 0 0 1 .81-.79Z"
          className="cls-20"
        />
        <rect
          width={41.32}
          height={10.89}
          x={127.92}
          y={176.37}
          className="cls-9"
          rx={1.4}
        />
        <rect
          width={41.32}
          height={10.89}
          x={127.92}
          y={176.37}
          className="cls-19"
          rx={1.4}
        />
        <rect
          width={29.91}
          height={6.57}
          x={135.17}
          y={178.53}
          rx={0.85}
          style={{
            opacity: 0.6,
            fill: "#407bff",
          }}
        />
        <path
          d="M158.54 171.15c-.77 0-1.4.37-1.4.83v3.57c0 .45.63.82 1.4.82h45.36c.25 0 .45-.12.45-.27v-4.68c0-.15-.2-.27-.45-.27Z"
          className="cls-9"
        />
        <path
          d="M185.2 171.65h19.15v4.22H185.2a.62.62 0 0 1-.62-.62v-3a.62.62 0 0 1 .62-.6Z"
          className="cls-20"
        />
        <rect
          width={48.61}
          height={5.22}
          x={135.05}
          y={171.15}
          className="cls-9"
          rx={1.07}
        />
        <rect
          width={48.61}
          height={5.22}
          x={135.05}
          y={171.15}
          className="cls-13"
          rx={1.07}
        />
        <rect
          width={1.87}
          height={5.22}
          x={140.3}
          y={171.15}
          className="cls-21"
          rx={0.21}
        />
        <rect
          width={1.84}
          height={5.22}
          x={178.05}
          y={171.15}
          className="cls-21"
          rx={0.21}
        />
        <path
          d="M150.34 163.61c-.77 0-1.4.37-1.4.83v5.89c0 .45.63.82 1.4.82h49.13c.25 0 .46-.12.46-.26v-7c0-.15-.21-.27-.46-.27Z"
          className="cls-9"
        />
        <path
          d="M177 164.11h22.93v6.55H177a.62.62 0 0 1-.62-.62v-5.31a.62.62 0 0 1 .62-.62Z"
          className="cls-20"
        />
        <rect
          width={41.32}
          height={7.54}
          x={134.13}
          y={163.61}
          className="cls-9"
          rx={1.07}
        />
        <rect
          width={41.32}
          height={7.54}
          x={134.13}
          y={163.61}
          rx={1.07}
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M259.92 194.45h-41.27a.84.84 0 0 0-.84.83.84.84 0 0 0 .84.83h41.27a.83.83 0 0 0 .83-.83.83.83 0 0 0-.83-.83Z"
          className="cls-15"
        />
        <path
          d="M340.66 192.47h27.12l2.45 3.54h-32.02l2.45-3.54z"
          className="cls-8"
        />
        <path d="M382.54 131.88a3.65 3.65 0 1 1-3.65-3.65 3.64 3.64 0 0 1 3.65 3.65Z" />
        <path
          d="M355.12 194.87a1 1 0 0 1-.45-.1 1.15 1.15 0 0 1-.62-1.5l26.13-61.84a1.16 1.16 0 0 1 2.13.9l-26.13 61.83a1.16 1.16 0 0 1-1.06.71Z"
          className="cls-8"
        />
        <path
          d="M381.24 133a1.12 1.12 0 0 1-.69-.23L333.1 97.23a1.15 1.15 0 1 1 1.38-1.84L381.94 131a1.15 1.15 0 0 1 .23 1.61 1.17 1.17 0 0 1-.93.39Z"
          className="cls-8"
        />
        <path
          d="M384.89 131.88a3.65 3.65 0 1 1-3.65-3.65 3.64 3.64 0 0 1 3.65 3.65Z"
          className="cls-8"
        />
        <circle cx={333.79} cy={96.31} r={3.64} className="cls-8" />
        <path
          d="M328.69 112.94a8.16 8.16 0 1 1 0-11.53 8.15 8.15 0 0 1 0 11.53Z"
          className="cls-9"
        />
        <path
          d="M328.69 112.94a8.16 8.16 0 1 1 0-11.53 8.15 8.15 0 0 1 0 11.53Z"
          className="cls-24"
        />
        <path
          d="M333.79 96.31a17.47 17.47 0 0 0-24.72 0L333.79 121a17.47 17.47 0 0 0 0-24.69Z"
          className="cls-8"
        />
        <g
          style={{
            opacity: 0.2,
          }}
        >
          <path
            d="m309.06 96.31-103.82 99.8h106.51l22.04-75.08-24.73-24.72z"
            className="cls-9"
          />
          <path
            d="m309.06 96.31-103.82 99.8h106.51l22.04-75.08-24.73-24.72z"
            className="cls-24"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const LockIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.423 9.448V7.3a4.552 4.552 0 0 0-4.551-4.551 4.55 4.55 0 0 0-4.57 4.53v2.168"
            stroke="#9B9C9F"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M15.683 21.25H8.042a3.792 3.792 0 0 1-3.792-3.792v-4.29a3.792 3.792 0 0 1 3.792-3.791h7.641a3.792 3.792 0 0 1 3.792 3.792v4.289a3.792 3.792 0 0 1-3.792 3.792Z"
            stroke="#9B9C9F"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.862 14.203v2.22"
            stroke="#9B9C9F"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EyeOpen = ({fill="#A2A3A4", ...props}) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.13 14.147a3.085 3.085 0 0 0 0-4.294C19.174 7.795 15.816 5 12 5 8.184 5 4.825 7.795 2.87 9.853a3.085 3.085 0 0 0 0 4.294C4.825 16.205 8.184 19 12 19c3.816 0 7.174-2.795 9.13-4.853ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            fill={fill}
        />
    </svg>
)

export const EyeClosed = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.47 4.53a.75.75 0 0 1 1.06-1.06l16 16a.75.75 0 1 1-1.06 1.06l-2.827-2.826C15.233 18.47 13.66 19 12 19c-3.816 0-7.175-2.795-9.13-4.853a3.085 3.085 0 0 1 0-4.294c.83-.873 1.912-1.879 3.175-2.748L3.47 4.53Zm5.945 5.946a3 3 0 0 0 4.109 4.109l-4.109-4.109ZM12 5c3.816 0 7.174 2.795 9.13 4.853a3.085 3.085 0 0 1 0 4.294c-.44.463-.95.963-1.522 1.46L9.413 5.414A8.633 8.633 0 0 1 12 5Z"
            fill="#A2A3A4"
        />
    </svg>
)
export const ArrowUpDown = (props) => (
    <svg
        width={12}
        height={12}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.225 3.36 3.365 1.5l-1.86 1.86M3.365 10.5v-9M6.775 8.64l1.86 1.86 1.86-1.86M8.635 1.5v9"
            stroke="#B2B2B2"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SearchIcon = (props) =>{
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.58268 17.5001C13.9549 17.5001 17.4993 13.9557 17.4993 9.58341C17.4993 5.21116 13.9549 1.66675 9.58268 1.66675C5.21043 1.66675 1.66602 5.21116 1.66602 9.58341C1.66602 13.9557 5.21043 17.5001 9.58268 17.5001Z" stroke={props.stroke || "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.334 18.3333L15.834 15.8333" stroke={props.stroke || "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const HelpIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#C4C4C4"/>
            <path d="M10.797 13.1433C10.797 12.6179 11.198 12.0122 12 11.326C12.3553 11.0151 12.5939 10.7739 12.7157 10.6023C12.8376 10.4201 12.8985 10.211 12.8985 9.97515C12.8985 9.68567 12.8071 9.44981 12.6244 9.26754C12.4416 9.08528 12.2132 8.99415 11.9391 8.99415C11.3807 8.99415 10.9594 9.40156 10.6751 10.2164L9 9.44444C9.2132 8.65107 9.57868 8.04532 10.0964 7.62719C10.6244 7.20906 11.2589 7 12 7C12.8528 7 13.5635 7.26267 14.132 7.78801C14.7107 8.31335 15 8.98879 15 9.81433C15 10.2539 14.9036 10.6506 14.7107 11.0044C14.5178 11.3582 14.1929 11.7442 13.736 12.1623C13.2792 12.5804 12.9848 12.8699 12.8528 13.0307C12.731 13.1915 12.6701 13.3738 12.6701 13.5775C12.6701 13.6311 12.6802 13.7437 12.7005 13.9152H10.9645C10.8528 13.6472 10.797 13.3899 10.797 13.1433ZM10.4619 16.5044C10.4619 16.0863 10.599 15.7325 10.8731 15.443C11.1472 15.1535 11.4873 15.0088 11.8934 15.0088C12.2995 15.0088 12.6345 15.1535 12.8985 15.443C13.1726 15.7325 13.3096 16.0863 13.3096 16.5044C13.3096 16.9332 13.1726 17.2924 12.8985 17.5819C12.6345 17.8606 12.2995 18 11.8934 18C11.4873 18 11.1472 17.8606 10.8731 17.5819C10.599 17.2924 10.4619 16.9332 10.4619 16.5044Z" fill="white"/>
        </svg>
    )
}

export const NotificationsIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.1912 12.06L16.0612 10.18C15.8112 9.77005 15.5912 8.98005 15.5912 8.50005V6.63005C15.5912 3.00005 12.6412 0.0500488 9.02118 0.0500488C5.39118 0.0600488 2.44118 3.00005 2.44118 6.63005V8.49005C2.44118 8.97005 2.22118 9.76005 1.98118 10.17L0.851179 12.05C0.421179 12.78 0.321179 13.61 0.591179 14.33C0.861179 15.06 1.47118 15.64 2.27118 15.9C3.35118 16.26 4.44118 16.52 5.55118 16.71C5.66118 16.73 5.77118 16.74 5.88118 16.76C6.02118 16.78 6.17118 16.8 6.32118 16.82C6.58118 16.86 6.84118 16.89 7.11118 16.91C7.74118 16.97 8.38118 17 9.02118 17C9.65118 17 10.2812 16.97 10.9012 16.91C11.1312 16.89 11.3612 16.87 11.5812 16.84C11.7612 16.82 11.9412 16.8001 12.1212 16.7701C12.2312 16.7601 12.3412 16.74 12.4512 16.72C13.5712 16.54 14.6812 16.26 15.7612 15.9C16.5312 15.64 17.1212 15.06 17.4012 14.32C17.6812 13.57 17.6012 12.75 17.1912 12.06ZM9.75118 8.00005C9.75118 8.42005 9.41118 8.76005 8.99118 8.76005C8.57118 8.76005 8.23118 8.42005 8.23118 8.00005V4.90005C8.23118 4.48005 8.57118 4.14005 8.99118 4.14005C9.41118 4.14005 9.75118 4.48005 9.75118 4.90005V8.00005Z" fill="#C4C4C4"/>
            <path d="M11.8297 18.01C11.4097 19.17 10.2997 20 8.99969 20C8.20969 20 7.42969 19.68 6.87969 19.11C6.55969 18.81 6.31969 18.41 6.17969 18C6.30969 18.02 6.43969 18.03 6.57969 18.05C6.80969 18.08 7.04969 18.11 7.28969 18.13C7.85969 18.18 8.43969 18.21 9.01969 18.21C9.58969 18.21 10.1597 18.18 10.7197 18.13C10.9297 18.11 11.1397 18.1 11.3397 18.07C11.4997 18.05 11.6597 18.03 11.8297 18.01Z" fill="#C4C4C4"/>
        </svg>
    )
}

export const UserIcon = ({fill="#454649", opacity=1}) => {
    return (
        <svg opacity={opacity} width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 8C9.20914 8 11 6.20914 11 4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4C3 6.20914 4.79086 8 7 8ZM7 18C10.866 18 14 16.2091 14 14C14 11.7909 10.866 10 7 10C3.13401 10 0 11.7909 0 14C0 16.2091 3.13401 18 7 18Z"
                fill={fill}
            />
        </svg>
    )
}

export const LockIconFilled = () => (
    <svg style={{opacity:"0.5"}} width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.75 4.75C4.75 2.95507 6.20507 1.5 8 1.5C9.79493 1.5 11.25 2.95507 11.25 4.75V6H4.75V4.75ZM3.25 6.0702V4.75C3.25 2.12665 5.37665 0 8 0C10.6234 0 12.75 2.12665 12.75 4.75V6.0702C14.6006 6.42125 16 8.04721 16 10V16C16 18.2091 14.2091 20 12 20H4C1.79086 20 0 18.2091 0 16V10C0 8.04721 1.39935 6.42125 3.25 6.0702ZM8 11.25C8.41421 11.25 8.75 11.5858 8.75 12V14C8.75 14.4142 8.41421 14.75 8 14.75C7.58579 14.75 7.25 14.4142 7.25 14V12C7.25 11.5858 7.58579 11.25 8 11.25Z" fill="#454649"/>
    </svg>

)

export const LogOutIcon = () => (
    <svg style={{opacity:"0.5"}} width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.47458 0.715509C5.16252 -0.409786 7.37968 0.621862 7.70853 2.51661H11C12.5188 2.51661 13.75 3.74783 13.75 5.26661C13.75 5.68083 13.4142 6.01661 13 6.01661C12.5858 6.01661 12.25 5.68083 12.25 5.26661C12.25 4.57626 11.6904 4.01661 11 4.01661H7.75V16.5166H11C11.6904 16.5166 12.25 15.957 12.25 15.2666C12.25 14.8524 12.5858 14.5166 13 14.5166C13.4142 14.5166 13.75 14.8524 13.75 15.2666C13.75 16.7854 12.5188 18.0166 11 18.0166H7.70853C7.37968 19.9114 5.16252 20.943 3.47458 19.8177L1.47457 18.4844C0.709528 17.9744 0.25 17.1157 0.25 16.1962V4.33698C0.25 3.41751 0.709528 2.55887 1.47457 2.04884L3.47458 0.715509ZM14.4697 12.5306C14.1768 12.2377 14.1768 11.7628 14.4697 11.4699L15.1893 10.7502L10 10.7502C9.58579 10.7502 9.25 10.4145 9.25 10.0002C9.25 9.58603 9.58579 9.25024 10 9.25024L15.1893 9.25025L14.4697 8.53057C14.1768 8.23768 14.1768 7.76281 14.4697 7.46991C14.7626 7.17702 15.2374 7.17702 15.5303 7.46991L16.8232 8.76281C17.5066 9.44623 17.5066 10.5543 16.8232 11.2377L15.5303 12.5306C15.2374 12.8235 14.7626 12.8235 14.4697 12.5306Z" fill="#454649"/>
    </svg>
)




export function EventFormatIcon(props) {
    return (
        <svg {...props} width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 0.25C1.0335 0.25 0.25 1.0335 0.25 2V4C0.25 4.9665 1.0335 5.75 2 5.75H4C4.9665 5.75 5.75 4.9665 5.75 4V2C5.75 1.0335 4.9665 0.25 4 0.25H2ZM2 8.25C1.0335 8.25 0.25 9.0335 0.25 10V12C0.25 12.9665 1.0335 13.75 2 13.75H4C4.9665 13.75 5.75 12.9665 5.75 12V10C5.75 9.0335 4.9665 8.25 4 8.25H2ZM8.25 1C8.25 0.585786 8.58579 0.25 9 0.25H15C15.4142 0.25 15.75 0.585786 15.75 1C15.75 1.41421 15.4142 1.75 15 1.75H9C8.58579 1.75 8.25 1.41421 8.25 1ZM9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H9ZM8.25 5C8.25 4.58579 8.58579 4.25 9 4.25H21C21.4142 4.25 21.75 4.58579 21.75 5C21.75 5.41421 21.4142 5.75 21 5.75H9C8.58579 5.75 8.25 5.41421 8.25 5ZM9 12.25C8.58579 12.25 8.25 12.5858 8.25 13C8.25 13.4142 8.58579 13.75 9 13.75H21C21.4142 13.75 21.75 13.4142 21.75 13C21.75 12.5858 21.4142 12.25 21 12.25H9Z" fill="#454649" />
        </svg>

    )
}

export function EventTypeIcon(props) {
    return (
        <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.94463 16.8165C3.03856 18.0471 4.96146 18.0471 6.05538 16.8165L7.56056 15.1231C7.83575 14.8135 7.80787 14.3395 7.49828 14.0643C7.18869 13.7891 6.71464 13.817 6.43945 14.1266L4.93427 15.8199C4.8774 15.8839 4.8156 15.9406 4.75 15.9899V2.00981C4.8156 2.05916 4.8774 2.11582 4.93427 2.1798L6.43945 3.87313C6.71464 4.18271 7.18869 4.2106 7.49828 3.93541C7.80787 3.66022 7.83575 3.18617 7.56056 2.87658L6.05538 1.18325C4.96146 -0.0474133 3.03856 -0.0474114 1.94463 1.18325L0.439451 2.87658C0.164263 3.18617 0.192148 3.66022 0.501735 3.93541C0.811322 4.2106 1.28538 4.18271 1.56056 3.87313L3.06575 2.1798C3.12261 2.11583 3.18441 2.05917 3.25 2.00983V15.9899C3.18441 15.9405 3.12261 15.8839 3.06575 15.8199L1.56056 14.1266C1.28538 13.817 0.811322 13.7891 0.501735 14.0643C0.192148 14.3395 0.164263 14.8135 0.439451 15.1231L1.94463 16.8165ZM11 2.99976C11 1.89519 11.8954 0.999756 13 0.999756H15C16.1046 0.999756 17 1.89519 17 2.99976V4.99976C17 6.10433 16.1046 6.99976 15 6.99976H13C11.8954 6.99976 11 6.10433 11 4.99976V2.99976ZM11 12.9998C11 11.8952 11.8954 10.9998 13 10.9998H15C16.1046 10.9998 17 11.8952 17 12.9998V14.9998C17 16.1043 16.1046 16.9998 15 16.9998H13C11.8954 16.9998 11 16.1043 11 14.9998V12.9998Z" fill="#454649" />
        </svg>

    )
}
export function CalendarIcon({
    opacity = '0.5', ...props
}) {
    return (
        <svg {...props} width="18" height="21" viewBox="0 0 18 21" fill="none" opacity={opacity} xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.75 1C5.75 0.585786 5.41421 0.25 5 0.25C4.58579 0.25 4.25 0.585786 4.25 1V2.5H4C1.79086 2.5 0 4.29086 0 6.5V7.25H18V6.5C18 4.29086 16.2091 2.5 14 2.5H13.75V1C13.75 0.585786 13.4142 0.25 13 0.25C12.5858 0.25 12.25 0.585786 12.25 1V2.5H5.75V1ZM0 8.75H18V17C18 19.2091 16.2091 21 14 21H4C1.79086 21 0 19.2091 0 17V8.75ZM9 15C9.55229 15 10 14.5523 10 14C10 13.4477 9.55229 13 9 13C8.44771 13 8 13.4477 8 14C8 14.5523 8.44771 15 9 15ZM14 14C14 14.5523 13.5523 15 13 15C12.4477 15 12 14.5523 12 14C12 13.4477 12.4477 13 13 13C13.5523 13 14 13.4477 14 14ZM5 15C5.55228 15 6 14.5523 6 14C6 13.4477 5.55228 13 5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15Z" fill="#454649" />
        </svg>
    )
}
export const EyeGreenIcon = ({fill="#7dba28", ...props}) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.13 14.147a3.085 3.085 0 0 0 0-4.294C19.174 7.795 15.816 5 12 5 8.184 5 4.825 7.795 2.87 9.853a3.085 3.085 0 0 0 0 4.294C4.825 16.205 8.184 19 12 19c3.816 0 7.174-2.795 9.13-4.853ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            fill={fill}
        />
    </svg>
)

export const EyeIcon20 = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6099 11.7904C18.5762 10.7737 18.5762 9.22894 17.6099 8.21222C15.9801 6.49741 13.1809 4.16797 10.0013 4.16797C6.82171 4.16797 4.02255 6.49741 2.39272 8.21222C1.42638 9.22895 1.42638 10.7737 2.39272 11.7904C4.02255 13.5052 6.82171 15.8346 10.0013 15.8346C13.1809 15.8346 15.9801 13.5052 17.6099 11.7904ZM10.0013 12.5013C11.382 12.5013 12.5013 11.382 12.5013 10.0013C12.5013 8.62059 11.382 7.5013 10.0013 7.5013C8.62059 7.5013 7.5013 8.62059 7.5013 10.0013C7.5013 11.382 8.62059 12.5013 10.0013 12.5013Z"
            fill="#FCFCFC"
        />
    </svg>
)

export const CalendarCheckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2V5" stroke="url(#paint0_linear_3325_30466)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 2V5" stroke="url(#paint1_linear_3325_30466)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="url(#paint2_linear_3325_30466)" strokeWidth="1.5"/>
        <path d="M9 15L10.7528 16.4023C11.1707 16.7366 11.7777 16.6826 12.1301 16.2799L15 13" stroke="url(#paint3_linear_3325_30466)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 9H21" stroke="url(#paint4_linear_3325_30466)" strokeWidth="1.5" strokeLinecap="round"/>
        <defs>
            <linearGradient id="paint0_linear_3325_30466" x1="8" y1="3.5" x2="9" y2="3.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DBA28"/>
                <stop offset="1" stopColor="#9ACA3F"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3325_30466" x1="16" y1="3.5" x2="17" y2="3.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DBA28"/>
                <stop offset="1" stopColor="#9ACA3F"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3325_30466" x1="3" y1="12.75" x2="21" y2="12.75" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DBA28"/>
                <stop offset="1" stopColor="#9ACA3F"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3325_30466" x1="9" y1="15" x2="15" y2="15" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DBA28"/>
                <stop offset="1" stopColor="#9ACA3F"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3325_30466" x1="3" y1="9.5" x2="21" y2="9.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DBA28"/>
                <stop offset="1" stopColor="#9ACA3F"/>
            </linearGradient>
        </defs>
    </svg>
)

export const ClockOutlined24 = ({stroke="#263238", ...props}) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g
            opacity={0.6}
            stroke={stroke}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                clipRule="evenodd"
                d="M21.25 12A9.25 9.25 0 0 1 12 21.25 9.25 9.25 0 0 1 2.75 12 9.25 9.25 0 0 1 12 2.75 9.25 9.25 0 0 1 21.25 12Z"
            />
            <path d="m15.432 14.943-3.77-2.25V7.848" />
        </g>
    </svg>
)

export const ClockOutlined20 = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M17.7096 10.0003C17.7096 14.2578 14.2588 17.7087 10.0013 17.7087C5.7438 17.7087 2.29297 14.2578 2.29297 10.0003C2.29297 5.74283 5.7438 2.29199 10.0013 2.29199C14.2588 2.29199 17.7096 5.74283 17.7096 10.0003Z" stroke="#7D8488" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.8604 12.4524L9.71875 10.5782V6.53906" stroke="#7D8488" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const ClockDashed = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 10 1.66675" stroke="#7D8488" strokeWidth="1.25" strokeLinecap="round"/>
        <path d="M18.3327 10.0001C18.3327 14.6025 14.6017 18.3334 9.99935 18.3334C5.39698 18.3334 1.66602 14.6025 1.66602 10.0001C1.66602 5.39771 5.39698 1.66675 9.99935 1.66675" stroke="#7D8488" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0.42 2.5"/>
        <path d="M11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10Z" stroke="#7D8488" strokeWidth="1.25"/>
        <path d="M11.2507 10H13.334M10.0007 5V8.75" stroke="#7D8488" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const CheckCircleIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.565 3.03146C12.431 2.37545 11.1143 2 9.71 2C5.45188 2 2 5.45188 2 9.71C2 13.9681 5.45188 17.42 9.71 17.42C13.9681 17.42 17.42 13.9681 17.42 9.71C17.42 8.76065 17.2484 7.85138 16.9346 7.0115M5.855 8.168L8.57387 10.3431C9.21173 10.8534 10.1369 10.7777 10.6833 10.1705L16.649 3.542"
            stroke="#7D8488"
            strokeWidth="1.25"
            strokeLinecap="round"
        />
    </svg>
)

export const Arrow24 = ({fill="#454649", ...props}) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.532 17.586a.75.75 0 0 1-.118-1.054L13.04 12 9.414 7.468a.75.75 0 1 1 1.172-.937l4 5a.75.75 0 0 1 0 .938l-4 5a.75.75 0 0 1-1.054.117Z"
            fill={fill}
        />
    </svg>
)

export const PlayBtn = (props) => (
    <svg
        width={12}
        height={14}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.564 5.346a2 2 0 0 1 0 3.308l-7.19 4.885C2.046 14.44.25 13.489.25 11.884V2.116C.25.51 2.046-.44 3.374.462l7.19 4.884Z"
            fill="#fff"
        />
    </svg>
)

export const FolderIcon = () => (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 3.375V14.625C0 14.8469 0.0206094 15.0638 0.0599478 15.2737L2.89483 8.82508C3.81764 6.67562 5.8941 5.25 8.22868 5.25H17.3049C17.1254 3.56252 15.7484 2.25 14.0763 2.25H10.7227C10.1448 2.25 9.57727 2.0898 9.0788 1.78592L6.91049 0.464081C6.41201 0.160203 5.84453 0 5.26659 0H3.24839C1.45435 0 0 1.51104 0 3.375ZM8.22865 6.75H17.3247H17.831C19.5143 6.75 20.554 8.65794 19.688 10.1576L16.4208 15.8152C15.638 17.1707 14.2282 18 12.7068 18H3.24834C2.34542 18 1.52855 17.6173 0.939819 16.9994L4.27076 9.42238C4.96592 7.7973 6.51701 6.75 8.22865 6.75Z" fill="#83C805"/>
    </svg>
)

export const TrashIcon = ({width=24, height=24, fill="white", ...props}) => (
    <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.25 4.75a2.75 2.75 0 0 1 5.5 0v.166c2.385.29 4.613.952 6.578 1.91a.75.75 0 0 1-.657 1.348C18.18 6.96 15.204 6.25 12 6.25c-3.204 0-6.18.71-8.672 1.924a.75.75 0 1 1-.657-1.348c1.966-.958 4.194-1.62 6.579-1.91V4.75Zm9.015 13.533a4 4 0 0 1-3.99 3.715h-4.55a4 4 0 0 1-3.99-3.715l-.689-9.635C7.164 7.91 9.52 7.498 12 7.498s4.836.412 6.954 1.15l-.689 9.635Zm-7.515-7.285a.75.75 0 0 0-1.5 0v6a.75.75 0 1 0 1.5 0v-6Zm3.25-.75a.75.75 0 0 1 .75.75v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
            fill={fill}
        />
    </svg>
)
export const TrashIcon2 =()=>(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.83725 2.41013C8.14636 1.94647 8.66675 1.66797 9.224 1.66797H10.7734C11.3306 1.66797 11.851 1.94647 12.1601 2.41014L12.9154 3.54297H16.0404C16.3855 3.54297 16.6654 3.82279 16.6654 4.16797C16.6654 4.51315 16.3855 4.79297 16.0404 4.79297H3.95703C3.61185 4.79297 3.33203 4.51315 3.33203 4.16797C3.33203 3.82279 3.61185 3.54297 3.95703 3.54297H7.08203L7.83725 2.41013ZM12.4993 18.3345H7.49935C5.6584 18.3345 4.16602 16.8421 4.16602 15.0011V5.83447H15.8327V15.0011C15.8327 16.8421 14.3403 18.3345 12.4993 18.3345ZM8.33268 8.54281C8.67786 8.54281 8.95768 8.82263 8.95768 9.16781V15.0011C8.95768 15.3463 8.67786 15.6261 8.33268 15.6261C7.9875 15.6261 7.70768 15.3463 7.70768 15.0011V9.16781C7.70768 8.82263 7.9875 8.54281 8.33268 8.54281ZM11.666 8.54281C12.0112 8.54281 12.291 8.82263 12.291 9.16781V15.0011C12.291 15.3463 12.0112 15.6261 11.666 15.6261C11.3208 15.6261 11.041 15.3463 11.041 15.0011V9.16781C11.041 8.82263 11.3208 8.54281 11.666 8.54281Z"
            fill="#EA4335"
        />
    </svg>

)
export const EditIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.419 3.677a2.312 2.312 0 0 1 3.27 0l1.634 1.635a2.312 2.312 0 0 1 0 3.269l-1.45 1.45a16.17 16.17 0 0 1-.357-.183c-.835-.44-1.827-1.057-2.567-1.797-.74-.74-1.357-1.732-1.797-2.567a16.251 16.251 0 0 1-.182-.358l1.449-1.449Zm-.53 5.434c.875.876 1.989 1.565 2.87 2.033l-5.699 5.7a2.312 2.312 0 0 1-1.308.654l-3.432.49a1.156 1.156 0 0 1-1.308-1.308l.49-3.432c.071-.495.3-.954.654-1.308l5.7-5.7c.468.882 1.157 1.996 2.033 2.871ZM3.75 19.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
            fill="#fff"
        />
    </svg>
)

export const CheckDoneIcon = (props) => (
    <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.5575 1.50173C15.8346 1.19385 15.8096 0.71963 15.5018 0.442536C15.1939 0.165442 14.7197 0.1904 14.4426 0.498283L8.42759 7.18158L7.46855 6.41436C7.1451 6.1556 6.67313 6.20804 6.41438 6.53149C6.15562 6.85493 6.20806 7.3269 6.53151 7.58566L7.42244 8.29841L6.70496 9.09561C6.26199 9.5878 5.51204 9.64915 4.99497 9.23549L1.46855 6.41436C1.1451 6.1556 0.673133 6.20804 0.414376 6.53149C0.155619 6.85493 0.20806 7.3269 0.531506 7.58566L4.05793 10.4068C5.19549 11.3168 6.84536 11.1819 7.8199 10.0991L8.59573 9.23703L10.0579 10.4068C11.1955 11.3168 12.8454 11.1819 13.8199 10.0991L21.5575 1.50173C21.8346 1.19385 21.8096 0.71963 21.5018 0.442536C21.1939 0.165442 20.7197 0.1904 20.4426 0.498283L12.705 9.09561C12.262 9.5878 11.512 9.64915 10.995 9.23549L9.60087 8.12021L15.5575 1.50173Z"
              fill={props.color || "white"}
        />
    </svg>
)

export const ImgIcon =()=>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.75 6C2.75 4.20507 4.20507 2.75 6 2.75H14C14.4142 2.75 14.75 2.41421 14.75 2C14.75 1.58579 14.4142 1.25 14 1.25H6C3.37665 1.25 1.25 3.37665 1.25 6V18C1.25 20.6234 3.37665 22.75 6 22.75H18C20.6234 22.75 22.75 20.6234 22.75 18V10C22.75 9.58579 22.4142 9.25 22 9.25C21.5858 9.25 21.25 9.58579 21.25 10V13.5091C21.2049 13.473 21.158 13.4387 21.1094 13.4063L18.7285 11.819C17.142 10.7613 15.0295 10.9705 13.6812 12.3188L10.3188 15.6812C8.9705 17.0295 6.85802 17.2387 5.27153 16.181L2.75 14.5V6ZM19.75 2C19.75 1.58579 19.4142 1.25 19 1.25C18.5858 1.25 18.25 1.58579 18.25 2V4.25H16C15.5858 4.25 15.25 4.58579 15.25 5C15.25 5.41421 15.5858 5.75 16 5.75H18.25V8C18.25 8.41421 18.5858 8.75 19 8.75C19.4142 8.75 19.75 8.41421 19.75 8V5.75H22C22.4142 5.75 22.75 5.41421 22.75 5C22.75 4.58579 22.4142 4.25 22 4.25H19.75V2ZM8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z" fill="#7DBA28"/>
    </svg>
)

export const LinkIcon =()=>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.1365 5.86369C16.5885 4.31562 14.0786 4.31562 12.5305 5.86369L10.8638 7.53036C10.5709 7.82326 10.0961 7.82326 9.80316 7.53036C9.51027 7.23747 9.51027 6.7626 9.80316 6.4697L11.4698 4.80303C13.6037 2.66917 17.0633 2.66917 19.1972 4.80303C21.3311 6.93688 21.3311 10.3965 19.1972 12.5304L17.5305 14.1971C17.2376 14.49 16.7628 14.49 16.4699 14.1971C16.177 13.9042 16.177 13.4293 16.4699 13.1364L18.1365 11.4697C19.6846 9.92167 19.6846 7.41175 18.1365 5.86369ZM14.6519 9.34858C14.9448 9.64147 14.9448 10.1163 14.6519 10.4092L10.4093 14.6519C10.1164 14.9448 9.64153 14.9448 9.34864 14.6519C9.05574 14.359 9.05574 13.8841 9.34864 13.5912L13.5913 9.34858C13.8842 9.05569 14.359 9.05569 14.6519 9.34858ZM11.4696 18.1371C9.92149 19.6851 7.41157 19.6851 5.8635 18.1371C4.31544 16.589 4.31544 14.0791 5.8635 12.531L7.53018 10.8643C7.82307 10.5715 7.82307 10.0966 7.53018 9.80368C7.23729 9.51079 6.76241 9.51079 6.46952 9.80368L4.80284 11.4704C2.66899 13.6042 2.66899 17.0639 4.80284 19.1977C6.9367 21.3316 10.3964 21.3316 12.5302 19.1977L14.1969 17.5311C14.4898 17.2382 14.4898 16.7633 14.1969 16.4704C13.904 16.1775 13.4291 16.1775 13.1362 16.4704L11.4696 18.1371Z" fill="#454649"/>
        </g>
    </svg>
)

export const UploadIcon =()=>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M17 4C18.4865 4 19.7205 5.08114 19.9585 6.5H4V5C4 3.34315 5.34315 2 7 2H9.56917C10.2372 2 10.8862 2.22298 11.4131 2.6336L12.3535 3.3664C12.8805 3.77702 13.5294 4 14.1975 4H17ZM20.526 8H3.47391C2.20062 8 1.25151 9.17404 1.5183 10.4191L3.32239 18.8381C3.71759 20.6824 5.34745 22 7.2336 22H16.7663C18.6524 22 20.2823 20.6824 20.6775 18.8381L22.4816 10.4191C22.7484 9.17403 21.7992 8 20.526 8ZM11.25 13.8279C11.2033 13.863 11.1586 13.9018 11.1161 13.9442L9.53033 15.53C9.23744 15.8229 8.76256 15.8229 8.46967 15.53C8.17678 15.2371 8.17678 14.7623 8.46967 14.4694L10.0555 12.8836C11.1294 11.8096 12.8706 11.8096 13.9445 12.8836L15.5303 14.4694C15.8232 14.7623 15.8232 15.2371 15.5303 15.53C15.2374 15.8229 14.7626 15.8229 14.4697 15.53L12.8839 13.9442C12.8414 13.9018 12.7967 13.863 12.75 13.8279V17.9997C12.75 18.4139 12.4142 18.7497 12 18.7497C11.5858 18.7497 11.25 18.4139 11.25 17.9997V13.8279Z" fill="#7DBA28"/>
    </svg>
)

export const ArrowDown = ({stroke="#1D1E22"}) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path d="M7 10L12 14L17 10" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
)

export const CheckCorrectCircleIcon =()=>(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48438 15.5156 0 10 0Z" fill="#82B432"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M14.834 6.62891C15.0762 6.87109 15.0762 7.26953 14.834 7.51172L8.97461 13.3711C8.85352 13.4922 8.69336 13.5547 8.5332 13.5547C8.37305 13.5547 8.21289 13.4922 8.0918 13.3711L5.16211 10.4414C4.91992 10.1992 4.91992 9.80078 5.16211 9.55859C5.4043 9.31641 5.80273 9.31641 6.04492 9.55859L8.5332 12.0469L13.9512 6.62891C14.1934 6.38281 14.5918 6.38281 14.834 6.62891Z" fill="white"/>
    </svg>
)

export const AddFileIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M22 10V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V7C2 4.79086 3.79086 3 6 3H8.66667C9.53215 3 10.3743 3.28071 11.0667 3.8L12.9333 5.2C13.6257 5.71929 14.4679 6 15.3333 6H18C20.2091 6 22 7.79086 22 10ZM12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V12.25H15C15.4142 12.25 15.75 12.5858 15.75 13C15.75 13.4142 15.4142 13.75 15 13.75H12.75V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V13.75H9C8.58579 13.75 8.25 13.4142 8.25 13C8.25 12.5858 8.58579 12.25 9 12.25H11.25V10C11.25 9.58579 11.5858 9.25 12 9.25Z" fill="#83C805"/>
    </svg>
)
export const DashboardIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2ZM6 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H6ZM4 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm12 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const UsersIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.963 11a3.993 3.993 0 0 0 3.985-4c0-2.21-1.784-4-3.985-4a3.993 3.993 0 0 0-3.985 4c0 2.21 1.784 4 3.985 4Zm0 10c3.852 0 6.974-1.79 6.974-4s-3.122-4-6.974-4c-3.852 0-6.974 1.79-6.974 4s3.122 4 6.974 4Zm3.947-10.184A5.492 5.492 0 0 0 15.443 7c0-.705-.132-1.378-.373-1.997A2.995 2.995 0 0 1 17.933 8a2.995 2.995 0 0 1-4.023 2.816ZM18.43 17c0 .539-.119 1.06-.341 1.552 1.7-.53 2.832-1.474 2.832-2.552 0-1.506-2.212-2.753-5.094-2.967 1.605 1 2.604 2.408 2.604 3.967Z"
            fill="#A2A3A4"
        />
    </svg>
)
export const RoleAssignmentIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3.25-1a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM16 16.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6ZM7 19c2.761 0 5-1.343 5-3s-2.239-3-5-3-5 1.343-5 3 2.239 3 5 3Z"
            fill="#A2A3A4"
        />
    </svg>
)
export const MentorsIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.725 4c0-.69.558-1.25 1.246-1.25h11.955c.688 0 1.246.56 1.246 1.25v6c0 .69-.558 1.25-1.246 1.25h-.996a.749.749 0 0 0-.747.75c0 .414.334.75.747.75h.996a2.745 2.745 0 0 0 2.74-2.75V4a2.745 2.745 0 0 0-2.74-2.75H7.971A2.745 2.745 0 0 0 5.23 4v1.5c0 .414.334.75.747.75a.749.749 0 0 0 .747-.75V4Zm.25 6c0 1.105-.893 2-1.993 2s-1.993-.895-1.993-2 .892-2 1.993-2c1.1 0 1.992.895 1.992 2Zm10.59-.594a.752.752 0 0 0-.224-1.037.746.746 0 0 0-1.032.226l-3.877 6.052a1.438 1.438 0 0 0-1.23.153L7.97 16.5V16c0-1.657-1.339-3-2.99-3a2.994 2.994 0 0 0-2.988 3v6H7.97v-2.32c.262-.04.521-.132.761-.283l4.012-2.142c.48-.301.725-.84.673-1.372l4.149-6.477ZM9.216 6c0-.414.335-.75.748-.75h7.97c.413 0 .748.336.748.75s-.335.75-.747.75h-7.97A.749.749 0 0 1 9.215 6Zm.748 2.25a.749.749 0 0 0-.747.75c0 .414.334.75.747.75h3.985a.749.749 0 0 0 .748-.75.749.749 0 0 0-.748-.75H9.963Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const CrmIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h.25v8H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-.25h8V20a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-.25V8H20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v.25H8V4a2 2 0 0 0-2-2H4Zm4 3.75V6a2 2 0 0 1-2 2h-.25v8H6a2 2 0 0 1 2 2v.25h8V18a2 2 0 0 1 2-2h.25V8H18a2 2 0 0 1-2-2v-.25H8Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const StartupIcon = ({width = 24, height = 24, fill = "#A2A3A4", ...props}) => (
    <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M20.088 1.6c-3.43 0-8.034 2.354-11.125 6.4H6.4C4.55 8 3.487 9.382 2.757 10.844L1.778 12.8H6.4l2.4 2.4 2.4 2.4v4.622l1.957-.978C14.618 20.514 16 19.452 16 17.6v-2.563c4.047-3.09 6.4-7.694 6.4-11.124V1.6h-2.312ZM16 6.4a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2ZM5.6 16l-.8.8c-1.155 1.156-1.6 4-1.6 4s2.717-.317 4-1.6l.8-.8L5.6 16Z"
            fill={fill}
        />
    </svg>
)

export const InvestorsIcon = ({width = 24, height = 24, fill = "#A2A3A4", ...props}) => (
    <svg
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.943 2.199c3.91.794 6.99 3.887 7.78 7.814.217 1.083-.7 1.987-1.804 1.987h-5.963a2 2 0 0 1-2-2V4c0-1.105.904-2.021 1.987-1.801ZM1.993 13c0-4.803 3.748-8.727 8.468-8.986V10c0 1.933 1.562 3.5 3.487 3.5h5.965c-.259 4.738-4.168 8.5-8.954 8.5-4.952 0-8.966-4.03-8.966-9Z"
            fill={fill}
        />
    </svg>
)
export const AppointmentIcon = ({fill = "#A2A3A4", props}) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.75 2a.75.75 0 0 0-1.5 0v1.5H7a4 4 0 0 0-4 4v.75h18V7.5a4 4 0 0 0-4-4h-.25V2a.75.75 0 0 0-1.5 0v1.5h-6.5V2ZM21 9.75H3V18a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V9.75Zm-5.435 3.744a.75.75 0 0 0-1.13-.988l-2.87 3.28a.25.25 0 0 1-.344.03L9.47 14.415a.75.75 0 1 0-.937 1.172l1.752 1.402a1.75 1.75 0 0 0 2.41-.214l2.87-3.28Z"
            fill={fill}
        />
    </svg>
)
export const CrowdfundingIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.602 5.25H8.398c-1.162-1.57.404-3.768 2.35-3.14l.927.3c.211.067.44.067.65 0l.928-.3c1.946-.628 3.512 1.57 2.35 3.14Zm-7.096 1.5h6.988c1.32.73 2.35 1.95 2.822 3.46l1.25 4c1.207 3.864-1.679 7.79-5.727 7.79h-3.678c-4.047 0-6.934-3.926-5.726-7.79l1.25-4a5.997 5.997 0 0 1 2.821-3.46ZM12.75 9.5a.75.75 0 0 0-1.5 0v.846c-1.106.288-2 1.197-2 2.404 0 1.472 1.328 2.5 2.75 2.5.788 0 1.25.539 1.25 1 0 .461-.462 1-1.25 1s-1.25-.539-1.25-1a.75.75 0 0 0-1.5 0c0 1.207.894 2.116 2 2.404v.846a.75.75 0 0 0 1.5 0v-.846c1.106-.288 2-1.197 2-2.404 0-1.472-1.328-2.5-2.75-2.5-.788 0-1.25-.539-1.25-1 0-.461.462-1 1.25-1s1.25.539 1.25 1a.75.75 0 0 0 1.5 0c0-1.207-.894-2.116-2-2.404V9.5Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const ItparkIcon = (props) => (
    <svg
        width={22}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m20.197 6.627-4.9-4.816A6.24 6.24 0 0 0 11 0C9.444.016 7.895.644 6.705 1.81l-4.9 4.817a5.976 5.976 0 0 0 0 8.56l.619.608c1.1 1.082 6.838 3.555 7.353 3.763v-9.353c0-.285-.198-.544-.47-.65L6.25 8.36a1.468 1.468 0 1 1 .514-1.303l2.973 1.162c.403.156.83.24 1.262.247.432-.005.86-.089 1.262-.247l2.977-1.162a1.466 1.466 0 1 1 .512 1.303l-3.06 1.195c-.271.106-.47.362-.47.65v9.353c.516-.208 6.253-2.68 7.355-3.763l.618-.609a5.976 5.976 0 0 0 .003-8.559Zm-9.196-.224a1.772 1.772 0 1 1 0-3.543 1.772 1.772 0 0 1 0 3.543Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const EventsIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.75 2a.75.75 0 0 0-1.5 0v1.5H7a4 4 0 0 0-4 4v.75h18V7.5a4 4 0 0 0-4-4h-.25V2a.75.75 0 0 0-1.5 0v1.5h-6.5V2ZM3 9.75h18V18a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9.75ZM12 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            fill="#A2A3A4"
        />
    </svg>
)
export const DemodaysIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 17a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h1.525l-2.168 3.614a.75.75 0 0 0 1.286.772L8.275 17h2.975v2a.75.75 0 0 0 1.5 0v-2h2.975l2.632 4.386a.75.75 0 1 0 1.286-.772L17.475 17H19ZM6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 7ZM7 11.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H7Z"
            fill="#A2A3A4"
        />
    </svg>
)
export const ProgramsIcon = (props) => (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V14.25H2V6ZM6 19C4.04721 19 2.42125 17.6006 2.0702 15.75H21.9298C21.5787 17.6006 19.9528 19 18 19H12.75V21.25H15C15.4142 21.25 15.75 21.5858 15.75 22C15.75 22.4142 15.4142 22.75 15 22.75H9C8.58579 22.75 8.25 22.4142 8.25 22C8.25 21.5858 8.58579 21.25 9 21.25H11.25V19H6ZM7 6.25C6.58579 6.25 6.25 6.58579 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75H12C12.4142 7.75 12.75 7.41421 12.75 7C12.75 6.58579 12.4142 6.25 12 6.25H7ZM6.25 11C6.25 10.5858 6.58579 10.25 7 10.25H17C17.4142 10.25 17.75 10.5858 17.75 11C17.75 11.4142 17.4142 11.75 17 11.75H7C6.58579 11.75 6.25 11.4142 6.25 11Z"
              fill="#A2A3A4"/>
    </svg>

)
export const PartnersIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.96 3.125a2.246 2.246 0 0 0-2.242 2.25v1c0 .414-.334.75-.747.75a.749.749 0 0 1-.747-.75v-1a3.743 3.743 0 0 1 3.736-3.75h1.992a3.743 3.743 0 0 1 3.737 3.75v1a.749.749 0 1 1-1.495 0v-1a2.246 2.246 0 0 0-2.242-2.25H10.96Z"
            fill="#A2A3A4"
        />
        <path
            d="M5.978 6.375h11.956a3.993 3.993 0 0 1 3.985 4s-2.343 2.302-8.284 2.55a.223.223 0 0 1-.22-.18 1.496 1.496 0 0 0-1.46-1.175c-.692 0-1.275.474-1.444 1.116a.223.223 0 0 1-.226.17c-5.953-.459-8.292-2.481-8.292-2.481 0-2.21 1.784-4 3.985-4Z"
            fill="#A2A3A4"
        />
        <path
            d="M10.461 14.258a.202.202 0 0 0-.187-.2c-4.672-.356-7.284-1.59-8.281-2.17v6.487c0 2.21 1.784 4 3.985 4h11.956a3.993 3.993 0 0 0 3.985-4v-6.446c-1 .658-3.618 2.031-8.275 2.235a.203.203 0 0 0-.194.201v.105c0 .829-.669 1.5-1.494 1.5a1.497 1.497 0 0 1-1.495-1.5v-.212Z"
            fill="#A2A3A4"
        />
        <rect
            x={11.209}
            y={12.375}
            width={1.494}
            height={2.794}
            rx={0.747}
            fill="#A2A3A4"
        />
    </svg>
)
export const TablesIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.993 6c0-2.21 1.784-4 3.985-4h11.956a3.993 3.993 0 0 1 3.985 4v1.25H1.993V6Zm0 2.75V18c0 2.21 1.784 4 3.985 4h1.245V8.75h-5.23ZM8.718 22h6.476V8.75H8.718V22Zm7.97 0h1.246a3.993 3.993 0 0 0 3.985-4V8.75h-5.23V22Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const SortGender = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.945 19.817a2.75 2.75 0 0 0 4.11 0l1.506-1.694a.75.75 0 1 0-1.122-.996L7.934 18.82c-.057.064-.118.12-.184.17V5.01c.066.05.127.106.184.17L9.44 6.873a.75.75 0 0 0 1.122-.996L9.055 4.183a2.75 2.75 0 0 0-4.11 0L3.439 5.877a.75.75 0 0 0 1.122.996L6.066 5.18a1.26 1.26 0 0 1 .184-.17v13.98a1.261 1.261 0 0 1-.184-.17L4.56 17.127a.75.75 0 1 0-1.122.996l1.506 1.694ZM14 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6Zm0 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2Z"
            fill="#454649"
            opacity={0.7}
        />
    </svg>
)

export const ExportIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 6v12a4 4 0 0 0 4 4h4.343c.308 0 .612-.035.907-.104V18A4.75 4.75 0 0 1 17 13.25h3.896c.069-.295.104-.6.104-.907V6a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4Zm11.172 14.828a4.013 4.013 0 0 1-.422.367V18A3.25 3.25 0 0 1 17 14.75h3.195a4.013 4.013 0 0 1-.367.422l-5.656 5.656Zm-1.288-10.772a1.247 1.247 0 0 1-.134.116V6a.75.75 0 0 0-1.5 0v4.172a1.247 1.247 0 0 1-.134-.117L9.53 8.47a.75.75 0 1 0-1.06 1.06l1.585 1.586a2.75 2.75 0 0 0 3.89 0L15.53 9.53a.75.75 0 0 0-1.06-1.06l-1.586 1.585Z"
            fill="#7DBA28"
        />
    </svg>
)
export const ExportToIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 6V18C3 20.2091 4.79086 22 7 22H11.3431C11.6509 22 11.955 21.9645 12.25 21.8959V18C12.25 15.3766 14.3766 13.25 17 13.25H20.8959C20.9645 12.955 21 12.6509 21 12.3431V6C21 3.79086 19.2091 2 17 2H7C4.79086 2 3 3.79086 3 6ZM14.1716 20.8284C14.039 20.961 13.898 21.0833 13.75 21.1949V18C13.75 16.2051 15.2051 14.75 17 14.75H20.1949C20.0833 14.898 19.961 15.039 19.8284 15.1716L14.1716 20.8284ZM11.1161 7.94449C11.1586 7.90202 11.2033 7.86325 11.25 7.82817V11.9999C11.25 12.4142 11.5858 12.7499 12 12.7499C12.4142 12.7499 12.75 12.4142 12.75 11.9999V7.82817C12.7967 7.86325 12.8414 7.90202 12.8839 7.94449L14.4697 9.53027C14.7626 9.82316 15.2374 9.82316 15.5303 9.53027C15.8232 9.23738 15.8232 8.76251 15.5303 8.46961L13.9445 6.88382C12.8706 5.80988 11.1294 5.80988 10.0555 6.88383L8.46967 8.46961C8.17678 8.76251 8.17678 9.23738 8.46967 9.53027C8.76256 9.82316 9.23744 9.82316 9.53033 9.53027L11.1161 7.94449Z"
            fill="#38CB89"
        />
    </svg>
)
export const AddBtnIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 7.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1 0-1.5h3.25V8a.75.75 0 0 1 .75-.75Z"
            fill="#fff"
        />
    </svg>
)
export const ImgSelectIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.75 6A3.25 3.25 0 0 1 6 2.75h8a.75.75 0 0 0 0-1.5H6A4.75 4.75 0 0 0 1.25 6v12A4.75 4.75 0 0 0 6 22.75h12A4.75 4.75 0 0 0 22.75 18v-8a.75.75 0 0 0-1.5 0v3.51a2.002 2.002 0 0 0-.14-.104l-2.381-1.587a4 4 0 0 0-5.048.5L10.32 15.68a4 4 0 0 1-5.047.5L2.75 14.5V6Zm17-4a.75.75 0 0 0-1.5 0v2.25H16a.75.75 0 0 0 0 1.5h2.25V8a.75.75 0 0 0 1.5 0V5.75H22a.75.75 0 0 0 0-1.5h-2.25V2ZM8.5 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            fill="#fcfcfc"
        />
    </svg>
)

export const CloseIcon = ({fill="#263238", opacity=0.5, ...props}) => (
    <svg
        width={36}
        height={36}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.568 25.16a1.125 1.125 0 0 0 1.591-1.592L19.591 18l5.568-5.569a1.125 1.125 0 1 0-1.59-1.59L18 16.409l-5.569-5.568a1.125 1.125 0 0 0-1.59 1.59L16.409 18l-5.568 5.569a1.125 1.125 0 0 0 1.59 1.59L18 19.592l5.568 5.568Z"
            fill={fill}
            opacity={opacity}
        />
    </svg>
)
export const CustomCloseIcon = ({fill="white", opacity=0.5, ...props}) => (
    <svg
        width={36}
        height={36}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.568 25.16a1.125 1.125 0 0 0 1.591-1.592L19.591 18l5.568-5.569a1.125 1.125 0 1 0-1.59-1.59L18 16.409l-5.569-5.568a1.125 1.125 0 0 0-1.59 1.59L16.409 18l-5.568 5.569a1.125 1.125 0 0 0 1.59 1.59L18 19.592l5.568 5.568Z"
            fill={fill}
            opacity={opacity}
        />
    </svg>
)
export const CloseIcon12 = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4613 11.736C10.8133 12.0879 11.384 12.0879 11.736 11.736C12.088 11.384 12.088 10.8133 11.736 10.4613L7.27469 5.99999L11.736 1.53871C12.088 1.18672 12.088 0.616033 11.736 0.264044C11.384 -0.0879441 10.8133 -0.0879441 10.4613 0.264044L6.00003 4.72533L1.53867 0.263992C1.18668 -0.0879974 0.615993 -0.0879969 0.264003 0.263991C-0.0879867 0.61598 -0.0879872 1.18667 0.264003 1.53865L4.72536 5.99999L0.263992 10.4613C-0.0879977 10.8133 -0.0879972 11.384 0.263992 11.736C0.615982 12.088 1.18667 12.088 1.53866 11.736L6.00003 7.27466L10.4613 11.736Z"
            fill="white"
        />
    </svg>
)
export const TelegramIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m2.897 10.796 15.388-6.65A1 1 0 0 1 19.67 5.22l-2.104 13.276a1 1 0 0 1-1.715.53l-3.453-3.657a2 2 0 0 1-.125-2.6l2.438-3.138c.14-.18-.08-.416-.27-.289l-4.847 3.252a4 4 0 0 1-2.8.637l-3.644-.527c-.998-.144-1.179-1.508-.253-1.908Z"
            fill="#454649"
            opacity={0.5}
        />
    </svg>
)

export const CheckboxIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 2H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4Zm-1.408 7.46a.75.75 0 0 0-1.184-.92l-4.007 5.151a.25.25 0 0 1-.365.033l-2.534-2.281a.75.75 0 1 0-1.004 1.114l2.535 2.282a1.75 1.75 0 0 0 2.552-.227l4.007-5.152Z"
            fill="#7DBA28"
        />
    </svg>
)

export const MaleGenderIcon = ({fill="#DEE0E1", ...props}) => (
    <svg
        width={18}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.25 12v-1.5c.338-.168 1.303-1.317 1.405-2.214.265-.02.682-.264.805-1.227.066-.516-.196-.807-.356-.898 0 0 .397-.753.397-1.66 0-1.822-.715-3.376-2.25-3.376C11.25 1.125 10.716 0 9 0 5.818 0 4.5 2.04 4.5 4.5c0 .828.395 1.66.395 1.66-.159.092-.421.383-.355.9.123.962.54 1.205.805 1.226.101.897 1.067 2.046 1.404 2.214V12C6 14.25 0 12.75 0 18h18c0-5.25-6-3.75-6.75-6Z"
            fill={fill}
        />
    </svg>
)

export const FemaleGenderIcon = ({fill="#DEE0E1", ...props}) => (
    <svg
        width={15}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 18c0-3.75 5.218-3.13 6-5.25V12c-2.833 0-4.436-1.413-4.436-1.413C3.045 9.355.994.782 6.037.782c0 0 .68-.782 1.56-.782 6.163 0 4.132 9.307 5.726 10.616 0 0-1.476 1.384-4.324 1.384v.75C9.782 14.87 15 14.25 15 18H0Z"
            fill={fill}
        />
    </svg>
)



export const GlobeIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 10.3431 17.5228 9 12 9C6.47715 9 2 10.3431 2 12M22 12C22 13.6569 17.5228 15 12 15C6.47715 15 2 13.6569 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2" stroke="#1D1E22" strokeOpacity="0.7" strokeWidth="1.5"/>
    </svg>
)

export const InstagramIcon = () => (
    <svg style={{opacity:0.7}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5 0C2.23858 0 0 2.23858 0 5V15C0 17.7614 2.23858 20 5 20H15C17.7614 20 20 17.7614 20 15V5C20 2.23858 17.7614 0 15 0H5ZM16 5C16.5523 5 17 4.55228 17 4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4C15 4.55228 15.4477 5 16 5ZM15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z" fill="#1D1E22"/>
    </svg>
)

export const FacebookIcon = () => (
    <svg style={{opacity:0.7}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0H4C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H8.5V14H5V11H8.5V9C8.5 6.79086 10.2909 5 12.5 5H15V8H12.5C11.9477 8 11.5 8.44772 11.5 9V11H15V14H11.5V20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0Z" fill="#1D1E22"/>
    </svg>
)

export const CloseCircleIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1644_10691)">
            <circle cx="12" cy="12" r="12" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.3588 15.3587C15.0659 15.6516 14.591 15.6516 14.2981 15.3587L12 13.0606L9.7019 15.3587C9.40901 15.6516 8.93413 15.6516 8.64124 15.3587C8.34835 15.0658 8.34835 14.5909 8.64124 14.298L10.9393 11.9999L8.64125 9.70184C8.34836 9.40895 8.34836 8.93408 8.64125 8.64118C8.93415 8.34829 9.40902 8.34829 9.70191 8.64118L12 10.9393L14.2981 8.64119C14.591 8.3483 15.0659 8.3483 15.3588 8.64119C15.6516 8.93409 15.6516 9.40896 15.3588 9.70185L13.0607 11.9999L15.3588 14.298C15.6517 14.5909 15.6517 15.0658 15.3588 15.3587Z" fill="#FF4B55"/>
        </g>
        <defs>
            <clipPath id="clip0_1644_10691">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)

export const AddPlusIcon = (props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H11.25V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H12.75V6Z" fill="#7DBA28"/>
    </svg>
)

export const AddPlusCircleIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3346 10.0013C18.3346 14.6037 14.6037 18.3346 10.0013 18.3346C5.39893 18.3346 1.66797 14.6037 1.66797 10.0013C1.66797 5.39893 5.39893 1.66797 10.0013 1.66797C14.6037 1.66797 18.3346 5.39893 18.3346 10.0013ZM10.0013 6.04297C10.3465 6.04297 10.6263 6.32279 10.6263 6.66797V9.3763H13.3346C13.6798 9.3763 13.9596 9.65612 13.9596 10.0013C13.9596 10.3465 13.6798 10.6263 13.3346 10.6263H10.6263V13.3346C10.6263 13.6798 10.3465 13.9596 10.0013 13.9596C9.65612 13.9596 9.3763 13.6798 9.3763 13.3346V10.6263H6.66797C6.32279 10.6263 6.04297 10.3465 6.04297 10.0013C6.04297 9.65612 6.32279 9.3763 6.66797 9.3763H9.3763V6.66797C9.3763 6.32279 9.65612 6.04297 10.0013 6.04297Z"
            fill="#FCFCFC"
        />
    </svg>
)

export const LocationIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="#7D7E80"/>
    </svg>
)

export const LocationOutlined = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 9.07416C17.5 13.1652 12.8125 18.3334 10 18.3334C7.1875 18.3334 2.5 13.1652 2.5 9.07416C2.5 4.98316 5.85786 1.66675 10 1.66675C14.1421 1.66675 17.5 4.98316 17.5 9.07416Z" stroke="#7D8488" strokeWidth="1.25"/>
        <path d="M12.5 9.16675C12.5 10.5475 11.3807 11.6667 10 11.6667C8.61929 11.6667 7.5 10.5475 7.5 9.16675C7.5 7.78604 8.61929 6.66675 10 6.66675C11.3807 6.66675 12.5 7.78604 12.5 9.16675Z" stroke="#7D8488" strokeWidth="1.25"/>
    </svg>
)

export const RejectIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.7128 16.7729C16.0057 17.0658 16.4805 17.0658 16.7734 16.7729C17.0663 16.48 17.0663 16.0052 16.7734 15.7123L13.0611 12L16.7734 8.2877C17.0663 7.99481 17.0663 7.51993 16.7734 7.22704C16.4805 6.93415 16.0057 6.93415 15.7128 7.22704L12.0005 10.9393L8.28815 7.22699C7.99526 6.9341 7.52038 6.9341 7.22749 7.22699C6.9346 7.51989 6.9346 7.99476 7.22749 8.28765L10.9398 12L7.22748 15.7123C6.93459 16.0052 6.93459 16.4801 7.22748 16.773C7.52038 17.0659 7.99525 17.0659 8.28814 16.773L12.0005 13.0606L15.7128 16.7729Z" fill="white"/>
    </svg>
)
export const Clear24Icon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-6.641 3.359a.75.75 0 0 1-1.06 0L12 13.06l-2.298 2.298a.75.75 0 1 1-1.06-1.061L10.938 12 8.641 9.702a.75.75 0 0 1 1.06-1.06L12 10.938l2.298-2.298a.75.75 0 0 1 1.06 1.06L13.062 12l2.298 2.298a.75.75 0 0 1 0 1.06Z"
            fill="#263238"
            opacity={0.5}
        />
    </svg>
)

export const SolidLayersIcon = () =>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7704 2.27641C11.5446 1.88931 12.4559 1.88931 13.2301 2.27641L20.5468 5.93477C21.8367 6.57969 21.8366 8.42035 20.5468 9.06526L13.2301 12.7236C12.4559 13.1107 11.5446 13.1107 10.7704 12.7236L3.4537 9.06526C2.16387 8.42034 2.16387 6.57968 3.45371 5.93477L10.7704 2.27641ZM2.31483 17.1953C2.48306 16.8168 2.92628 16.6464 3.30479 16.8146L11.4925 20.4536C11.8157 20.5972 12.1847 20.5972 12.5079 20.4536L20.6956 16.8146C21.0741 16.6464 21.5173 16.8168 21.6855 17.1953C21.8538 17.5739 21.6833 18.0171 21.3048 18.1853L13.1171 21.8243C12.406 22.1403 11.5944 22.1403 10.8833 21.8243L2.69558 18.1853C2.31707 18.0171 2.1466 17.5739 2.31483 17.1953ZM3.30479 12.3146C2.92628 12.1464 2.48306 12.3168 2.31483 12.6953C2.1466 13.0739 2.31707 13.5171 2.69558 13.6853L10.8833 17.3243C11.5944 17.6403 12.406 17.6403 13.1171 17.3243L21.3048 13.6853C21.6833 13.5171 21.8538 13.0739 21.6855 12.6953C21.5173 12.3168 21.0741 12.1464 20.6956 12.3146L12.5079 15.9536C12.1847 16.0972 11.8157 16.0972 11.4925 15.9536L3.30479 12.3146Z"
            fill="#7D7E80"/>
    </svg>
)

export const RefreshIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.66873 3 5.76018 4.80989 4.20404 7.5M4.20404 7.5V3M4.20404 7.5H8.625"
              stroke="url(#paint0_linear_1938_13604)"
              strokeOpacity="0.5"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"/>
        <defs>
            <linearGradient id="paint0_linear_1938_13604" x1="21" y1="12.3437" x2="3" y2="12.3437" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2E3138"/>
                <stop offset="1" stopColor="#282B30"/>
            </linearGradient>
        </defs>
    </svg>
)

export const ReloadIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.8571 2L16.0352 5.09076C14.8506 4.39741 13.4717 4 12 4C7.58172 4 4 7.58172 4 12C4 13.4571 4.38958 14.8233 5.07026 16M9.14286 22L7.96473 18.9092C9.14936 19.6026 10.5283 20 12 20C16.4183 20 20 16.4183 20 12C20 10.5429 19.6104 9.17669 18.9297 8"
            stroke="#FCFCFC"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
)

export const RightArrow = ({...props}) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 16L18 12M18 12L14 8M18 12L6 12" stroke="#7DBA28" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const InfoCircleOutlinedIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 8V9M12 11.5V16M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#7DBA28"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
)

export const LinkedinIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4ZM6 8.5V22H2V8.5H6ZM9 8.5H13V9.34141C13.6256 9.12031 14.2987 9 15 9C18.3137 9 21 11.6863 21 15V22H17V15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15V22H9V15V8.5Z"
                fill="#1D1E22"
            />
        </g>
    </svg>
)

export const MailFilledIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V7C22 4.79086 20.2091 3 18 3H6ZM6.41603 7.37592C6.07138 7.14616 5.60573 7.23929 5.37597 7.58393C5.1462 7.92858 5.23933 8.39423 5.58398 8.624L9.36518 11.1448C10.9607 12.2085 13.0393 12.2085 14.6348 11.1448L18.416 8.624C18.7607 8.39423 18.8538 7.92858 18.624 7.58393C18.3943 7.23929 17.9286 7.14616 17.584 7.37592L13.8028 9.89672C12.7111 10.6245 11.2889 10.6245 10.1972 9.89672L6.41603 7.37592Z"
            fill="#28303F"
            fillOpacity="0.7"
        />
    </svg>
)

export const Trash16Icon = (props) => (
    <svg
        width={16}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.167 3.17a1.833 1.833 0 0 1 3.666 0v.11c1.59.193 3.076.635 4.386 1.273a.5.5 0 1 1-.438.9c-1.661-.81-3.645-1.284-5.78-1.284-2.137 0-4.12.474-5.782 1.283a.5.5 0 1 1-.438-.899A13.843 13.843 0 0 1 6.167 3.28v-.11Zm6.01 9.021a2.667 2.667 0 0 1-2.66 2.477H6.483a2.667 2.667 0 0 1-2.66-2.477l-.459-6.423A14.102 14.102 0 0 1 8 5c1.654 0 3.224.275 4.636.767l-.459 6.423Zm-5.01-4.856a.5.5 0 1 0-1 0v4a.5.5 0 1 0 1 0v-4Zm2.166-.5a.5.5 0 0 1 .5.5v4a.5.5 0 1 1-1 0v-4a.5.5 0 0 1 .5-.5Z"
            fill="#fff"
        />
    </svg>
)
export const Edit16Icon = (props) => (
    <svg
        width={16}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.28 2.451a1.541 1.541 0 0 1 2.179 0l1.09 1.09a1.541 1.541 0 0 1 0 2.18l-.967.966a10.78 10.78 0 0 1-.238-.122c-.557-.293-1.218-.705-1.711-1.198-.493-.493-.905-1.154-1.198-1.711a10.781 10.781 0 0 1-.122-.238l.966-.967Zm-.354 3.623c.583.584 1.326 1.043 1.914 1.356l-3.8 3.8a1.54 1.54 0 0 1-.872.435l-2.288.327a.77.77 0 0 1-.872-.872l.327-2.288c.047-.33.2-.636.436-.872l3.8-3.8c.312.588.771 1.33 1.355 1.914ZM2.5 13a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
            fill="#fff"
        />
    </svg>
)
// modalProps
export const TrendUpIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.9427 3.85537C9.88539 3.71488 9.77079 3.59917 9.63162 3.54132C9.56613 3.51653 9.49245 3.5 9.41878 3.5H7.89614C7.57687 3.5 7.3231 3.7562 7.3231 4.07851C7.3231 4.40083 7.57687 4.65703 7.89614 4.65703H8.04349L6.31619 6.40083L5.4812 5.14463C5.38296 5.00413 5.23561 4.90496 5.0637 4.88843C4.8836 4.8719 4.72806 4.92975 4.60527 5.05372L2.16577 7.51653C1.94474 7.73967 1.94474 8.10331 2.16577 8.33471C2.28038 8.45041 2.41954 8.5 2.5669 8.5C2.71425 8.5 2.8616 8.44215 2.96802 8.33471L4.91635 6.36777L5.75134 7.62397C5.84958 7.76446 5.99693 7.86364 6.16884 7.88017C6.34894 7.89669 6.50448 7.83884 6.62727 7.71488L8.85393 5.46694V5.6157C8.85393 5.93802 9.1077 6.19421 9.42696 6.19421C9.74623 6.19421 10 5.93802 10 5.6157V4.07025C9.98363 3.99587 9.97544 3.92149 9.9427 3.85537Z"
            fill="#38CB89"
        />
    </svg>
)
export const DashboardUsersTripleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 14.666C18.2091 14.666 20 12.8752 20 10.666C20 8.45688 18.2091 6.66602 16 6.66602C13.7909 6.66602 12 8.45688 12 10.666C12 12.8752 13.7909 14.666 16 14.666ZM16 25.3325C20.4183 25.3325 24 23.5417 24 21.3325C24 19.1234 20.4183 17.3325 16 17.3325C11.5817 17.3325 8 19.1234 8 21.3325C8 23.5417 11.5817 25.3325 16 25.3325ZM8.51018 17.3581C5.21729 17.5611 2.66797 18.9648 2.66797 20.6662C2.66797 22.0688 4.40062 23.2691 6.85414 23.7611C6.30588 23.0187 6.0013 22.1971 6.0013 21.3328C6.0013 19.8083 6.94898 18.4165 8.51018 17.3581ZM26.0011 21.3327C26.0011 22.197 25.6965 23.0186 25.1482 23.761C27.6017 23.2689 29.3344 22.0686 29.3344 20.666C29.3344 18.9646 26.7851 17.561 23.4922 17.3579C25.0534 18.4164 26.0011 19.8081 26.0011 21.3327ZM20.9609 14.0464C21.6186 13.0837 22.0032 11.9197 22.0032 10.6659C22.0032 10.2498 21.9609 9.84359 21.8802 9.45137C22.1298 9.37412 22.395 9.33252 22.6699 9.33252C24.1426 9.33252 25.3365 10.5264 25.3365 11.9992C25.3365 13.4719 24.1426 14.6659 22.6699 14.6659C22.0196 14.6659 21.4237 14.4331 20.9609 14.0464ZM9.33464 9.33268C9.60955 9.33268 9.87475 9.37428 10.1243 9.45154C10.0437 9.84375 10.0013 10.2499 10.0013 10.666C10.0013 11.9199 10.3859 13.0839 11.0436 14.0465C10.5808 14.4333 9.9849 14.666 9.33464 14.666C7.86188 14.666 6.66797 13.4721 6.66797 11.9993C6.66797 10.5266 7.86188 9.33268 9.33464 9.33268Z"
            fill="#7DBA28"
        />
    </svg>
)
export const DashboardStartupIcon = () => (
    <svg width="32" height="32" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.4352 1.86719C19.4329 1.86719 14.0625 4.61305 10.4561 9.33386H7.46646C5.30617 9.33386 4.06801 10.9463 3.2155 12.6515L2.07422 14.9339H4.76857H7.46646L10.2665 17.7339L13.0665 20.5339V23.2318V25.9261L15.3488 24.785C17.054 23.9323 18.6665 22.6942 18.6665 20.5339V17.5442C23.3873 13.9378 26.1331 8.5674 26.1331 4.56508V1.86719H23.4352ZM18.6665 7.46719C19.6974 7.46719 20.5331 8.3029 20.5331 9.33386C20.5331 10.3648 19.6974 11.2005 18.6665 11.2005C17.6355 11.2005 16.7998 10.3648 16.7998 9.33386C16.7998 8.3029 17.6355 7.46719 18.6665 7.46719ZM6.53313 18.6672L5.59979 19.6005C4.25169 20.9486 3.73313 24.2672 3.73313 24.2672C3.73313 24.2672 6.90273 23.8976 8.39979 22.4005L9.33313 21.4672L6.53313 18.6672Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardInvestorIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9924 2.81501C23.7606 3.67957 28.3202 8.23911 29.1847 14.0073C29.3485 15.0997 28.4373 16.0004 27.3327 16.0004H17.9993C16.8948 16.0004 15.9993 15.105 15.9993 14.0004V4.66705C15.9993 3.56248 16.9 2.65128 17.9924 2.81501ZM2.66602 17.3337C2.66602 10.93 7.68202 5.69787 13.9994 5.35195V13.3338C13.9994 15.9111 16.0887 18.0005 18.666 18.0005H26.6478C26.3019 24.3178 21.0697 29.3337 14.666 29.3337C8.0386 29.3337 2.66602 23.9612 2.66602 17.3337Z"
            fill="#7DBA28"/>
    </svg>
)
export const DashboardAppointmentIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6667 2.66699C11.6667 2.11471 11.219 1.66699 10.6667 1.66699C10.1144 1.66699 9.66667 2.11471 9.66667 2.66699V4.66699H8C5.79086 4.66699 4 6.45785 4 8.66699V11.0003H28V8.66699C28 6.45785 26.2091 4.66699 24 4.66699H22.3333V2.66699C22.3333 2.11471 21.8856 1.66699 21.3333 1.66699C20.781 1.66699 20.3333 2.11471 20.3333 2.66699V4.66699H11.6667V2.66699ZM28 13.0003H4V25.3337C4 27.5428 5.79086 29.3337 8 29.3337H24C26.2091 29.3337 28 27.5428 28 25.3337V13.0003ZM20.7526 17.9922C21.1163 17.5765 21.0742 16.9448 20.6585 16.5811C20.2429 16.2174 19.6111 16.2595 19.2475 16.6752L15.4209 21.0484C15.3035 21.1826 15.1011 21.2006 14.9618 21.0891L12.6247 19.2195C12.1935 18.8745 11.5642 18.9444 11.2192 19.3756C10.8742 19.8069 10.9441 20.4362 11.3753 20.7812L13.7124 22.6509C14.6875 23.4309 16.1038 23.3051 16.9261 22.3654L20.7526 17.9922Z"
            fill="#7DBA28"/>
    </svg>
)
export const DashboardResidentsIcon = () => (
    <svg width="32" height="32" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.8693 7.83245L18.0774 2.13995C16.6739 0.760756 14.8407 0.018975 13.0009 0C11.1614 0.018975 9.32993 0.760756 7.92437 2.13995L2.13279 7.83245C1.45777 8.49046 0.9213 9.27695 0.555005 10.1456C0.188709 11.0142 0 11.9473 0 12.89C0 13.8327 0.188709 14.7658 0.555005 15.6344C0.9213 16.503 1.45777 17.2895 2.13279 17.9475L2.86438 18.6665C4.16452 19.9459 10.9463 22.8684 11.5549 23.1143V12.0607C11.5549 11.7237 11.3202 11.417 10.9983 11.2922L7.3871 9.88034C7.09151 10.128 6.7218 10.2701 6.3364 10.2842C5.95101 10.2983 5.57192 10.1835 5.25906 9.95802C4.94619 9.73254 4.71739 9.40923 4.60883 9.03918C4.50026 8.66913 4.51812 8.27345 4.65958 7.91468C4.80104 7.55591 5.05804 7.25453 5.38994 7.05815C5.72185 6.86178 6.10974 6.78162 6.49229 6.83035C6.87485 6.87908 7.23026 7.05392 7.50234 7.32723C7.77441 7.60053 7.94765 7.95673 7.99465 8.3395L11.5085 9.71378C11.9845 9.89823 12.4894 9.99686 12.9998 10.0051C13.5105 9.99878 14.0159 9.90009 14.4915 9.71378L18.0092 8.3395C18.0502 8.00838 18.186 7.69614 18.4001 7.44029C18.6143 7.18444 18.8977 6.99587 19.2165 6.89721C19.5352 6.79856 19.8756 6.79403 20.1969 6.88417C20.5181 6.97431 20.8065 7.15528 21.0274 7.40534C21.2483 7.6554 21.3923 7.96392 21.4421 8.29383C21.4919 8.62374 21.4454 8.96101 21.3081 9.26513C21.1709 9.56925 20.9488 9.82727 20.6684 10.0082C20.3881 10.1892 20.0615 10.2853 19.7279 10.2851C19.3206 10.2865 18.9262 10.143 18.615 9.88034L14.9996 11.2922C14.6781 11.417 14.4433 11.7199 14.4433 12.0607V23.1143C15.0526 22.8684 21.8327 19.9459 23.1349 18.6665L23.8654 17.9472C24.5407 17.2894 25.0774 16.5031 25.444 15.6347C25.8106 14.7663 25.9996 13.8333 26 12.8906C26.0004 11.948 25.812 11.0148 25.4461 10.1461C25.0802 9.27739 24.544 8.49072 23.8693 7.83245ZM13.0009 7.5675C12.5868 7.5675 12.182 7.4447 11.8377 7.21464C11.4934 6.98458 11.2251 6.65759 11.0666 6.27502C10.9082 5.89245 10.8668 5.47148 10.9476 5.06536C11.0284 4.65924 11.2278 4.2862 11.5206 3.99342C11.8135 3.70065 12.1865 3.50128 12.5927 3.42054C12.9988 3.3398 13.4198 3.38131 13.8023 3.53982C14.1848 3.69833 14.5118 3.96672 14.7418 4.31106C14.9718 4.65539 15.0945 5.06019 15.0944 5.47428C15.0939 6.02932 14.8731 6.56147 14.4806 6.95392C14.0881 7.34636 13.5559 7.56703 13.0009 7.5675Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardEventIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.6667 2.66699C11.6667 2.11471 11.219 1.66699 10.6667 1.66699C10.1144 1.66699 9.66667 2.11471 9.66667 2.66699V4.66699H8C5.79086 4.66699 4 6.45785 4 8.66699V11.0003H28V8.66699C28 6.45785 26.2091 4.66699 24 4.66699H22.3333V2.66699C22.3333 2.11471 21.8856 1.66699 21.3333 1.66699C20.781 1.66699 20.3333 2.11471 20.3333 2.66699V4.66699H11.6667V2.66699ZM4 13.0003H28V25.3337C28 27.5428 26.2091 29.3337 24 29.3337H8C5.79086 29.3337 4 27.5428 4 25.3337V13.0003ZM16 21.3337C16.7364 21.3337 17.3333 20.7367 17.3333 20.0003C17.3333 19.2639 16.7364 18.667 16 18.667C15.2636 18.667 14.6667 19.2639 14.6667 20.0003C14.6667 20.7367 15.2636 21.3337 16 21.3337ZM22.6667 20.0003C22.6667 20.7367 22.0697 21.3337 21.3333 21.3337C20.597 21.3337 20 20.7367 20 20.0003C20 19.2639 20.597 18.667 21.3333 18.667C22.0697 18.667 22.6667 19.2639 22.6667 20.0003ZM10.6667 21.3337C11.403 21.3337 12 20.7367 12 20.0003C12 19.2639 11.403 18.667 10.6667 18.667C9.93029 18.667 9.33333 19.2639 9.33333 20.0003C9.33333 20.7367 9.93029 21.3337 10.6667 21.3337Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardDemoDaysIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M25.3327 22.667C27.5418 22.667 29.3327 20.8761 29.3327 18.667L29.3327 6.667C29.3327 4.45786 27.5418 2.66699 25.3327 2.66699H6.66602C4.45688 2.66699 2.66602 4.45785 2.66602 6.66699V18.667C2.66602 20.8761 4.45688 22.667 6.66601 22.667H8.69991L5.80851 27.486C5.52436 27.9596 5.67793 28.5738 6.15151 28.858C6.62509 29.1421 7.23935 28.9886 7.5235 28.515L11.0323 22.667L14.9993 22.667V25.3338C14.9993 25.8861 15.4471 26.3338 15.9993 26.3338C16.5516 26.3338 16.9993 25.8861 16.9993 25.3338V22.667H20.9664L24.4752 28.515C24.7593 28.9886 25.3736 29.1421 25.8472 28.858C26.3207 28.5738 26.4743 27.9596 26.1902 27.486L23.2988 22.667H25.3327ZM8.33268 9.33366C8.33268 8.78137 8.7804 8.33366 9.33268 8.33366H22.666C23.2183 8.33366 23.666 8.78137 23.666 9.33366C23.666 9.88594 23.2183 10.3337 22.666 10.3337H9.33268C8.7804 10.3337 8.33268 9.88594 8.33268 9.33366ZM9.33268 15.0003C8.7804 15.0003 8.33268 15.448 8.33268 16.0003C8.33268 16.5526 8.7804 17.0003 9.33268 17.0003H15.9993C16.5516 17.0003 16.9993 16.5526 16.9993 16.0003C16.9993 15.448 16.5516 15.0003 15.9993 15.0003H9.33268Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardPartnersIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.666 4.16699C13.0092 4.16699 11.666 5.51014 11.666 7.16699V8.50033C11.666 9.05261 11.2183 9.50033 10.666 9.50033C10.1137 9.50033 9.66602 9.05261 9.66602 8.50033V7.16699C9.66602 4.40557 11.9046 2.16699 14.666 2.16699H17.3327C20.0941 2.16699 22.3327 4.40557 22.3327 7.16699V8.50033C22.3327 9.05261 21.885 9.50033 21.3327 9.50033C20.7804 9.50033 20.3327 9.05261 20.3327 8.50033V7.16699C20.3327 5.51014 18.9895 4.16699 17.3327 4.16699H14.666Z" fill="#7DBA28"/>
        <path d="M7.99935 8.5H23.9993C26.9449 8.5 29.3327 10.8878 29.3327 13.8333C29.3327 13.8333 26.18 16.9186 18.1824 17.2358C18.0764 17.2401 17.9845 17.1601 17.965 17.0559C17.7909 16.1287 16.9771 15.4271 15.9993 15.4271C15.05 15.4271 14.2552 16.0885 14.0505 16.9757C14.0268 17.0786 13.9322 17.1546 13.8269 17.1467C5.81355 16.5439 2.66602 13.8333 2.66602 13.8333C2.66602 10.8878 5.05383 8.5 7.99935 8.5Z" fill="#7DBA28"/>
        <path d="M13.9993 18.9489C13.9993 18.8438 13.9164 18.7566 13.8116 18.7488C7.52 18.2806 4.00494 16.6275 2.66602 15.8501V24.5C2.66602 27.4455 5.05383 29.8334 7.99935 29.8334H23.9993C26.9449 29.8334 29.3327 27.4455 29.3327 24.5V15.9058C27.9907 16.7853 24.467 18.6266 18.1938 18.8887C18.0863 18.8932 17.9993 18.9815 17.9993 19.0891V19.2938C17.9993 20.3983 17.1039 21.2937 15.9993 21.2937C14.8948 21.2937 13.9993 20.3983 13.9993 19.2938V18.9489Z" fill="#7DBA28"/>
        <rect x="15" y="16.5" width="2" height="3.72537" rx="1" fill="#7DBA28"/>
    </svg>
)
export const DashboardIdeationIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8108_57169)">
            <path d="M14.9326 27.0973H13.0659C12.0392 27.0973 11.1992 26.2844 11.1992 25.2908V23.4844H16.7992V25.2908C16.7992 26.2844 15.9592 27.0973 14.9326 27.0973Z" fill="#7DBA28" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round"/>
            <path d="M20.5354 13.5482C20.5354 15.8062 19.4154 17.974 17.5487 19.3288L16.8021 19.8707V23.4837H11.2021V19.8707L10.4554 19.3288C8.58875 17.974 7.46875 15.8062 7.46875 13.5482C7.46875 10.0256 10.3621 7.22559 14.0021 7.22559C17.6421 7.22559 20.5354 10.0256 20.5354 13.5482Z" fill="#7DBA28" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinejoin="round"/>
            <path d="M14 4.51622V0.90332" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7.37505 7.13548L4.76172 4.60645" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20.6289 7.13548L23.2422 4.60645" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.66693 13.5488H0.933594" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23.332 13.5488H27.0654" stroke="#7DBA28" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_8108_57169">
                <rect width="28" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)
export const DashboardTaskCheckIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.0417 4.66667C11.0417 3.19391 12.2356 2 13.7083 2H19.0417C20.5144 2 21.7083 3.19391 21.7083 4.66667C21.7083 6.13943 20.5144 7.33333 19.0417 7.33333H13.7083C12.2356 7.33333 11.0417 6.13943 11.0417 4.66667ZM9.04167 4.66676L8.375 4.66677C6.16586 4.66677 4.375 6.45763 4.375 8.66677V24.6668C4.375 26.8759 6.16586 28.6668 8.375 28.6668H24.375C26.5841 28.6668 28.375 26.8759 28.375 24.6668V8.66677C28.375 6.45763 26.5841 4.66677 24.375 4.66677L23.7083 4.66676C23.7083 7.24409 21.619 9.33343 19.0417 9.33343H13.7083C11.131 9.33343 9.04167 7.24409 9.04167 4.66676ZM21.1276 15.9919C21.4913 15.5762 21.4492 14.9445 21.0335 14.5808C20.6179 14.2171 19.9861 14.2592 19.6225 14.6748L15.7959 19.048C15.6785 19.1823 15.4761 19.2003 15.3368 19.0888L12.9997 17.2191C12.5685 16.8741 11.9392 16.9441 11.5942 17.3753C11.2492 17.8066 11.3191 18.4359 11.7503 18.7809L14.0874 20.6506C15.0625 21.4306 16.4788 21.3048 17.3011 20.365L21.1276 15.9919Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardChartArrowUpIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M25.3347 1.66699C24.7825 1.66699 24.3347 2.11471 24.3347 2.66699C24.3347 3.21928 24.7825 3.66699 25.3347 3.66699H26.8181C21.8255 7.64854 18.0264 10.1699 14.4143 11.8453C10.6844 13.5753 7.10626 14.4251 2.54133 15.0084C1.9935 15.0784 1.60614 15.5792 1.67614 16.1271C1.74614 16.6749 2.247 17.0623 2.79483 16.9923C7.48606 16.3928 11.2803 15.5035 15.2558 13.6596C19.1429 11.8568 23.1574 9.16248 28.3347 5.01514V6.66699C28.3347 7.21928 28.7825 7.66699 29.3347 7.66699C29.887 7.66699 30.3347 7.21928 30.3347 6.66699V4.00033C30.3347 2.71166 29.2901 1.66699 28.0014 1.66699H25.3347ZM29.3348 13.3337C29.3348 11.8609 28.1409 10.667 26.6681 10.667C25.1954 10.667 24.0015 11.8609 24.0015 13.3337L24.0015 26.667C24.0015 28.1398 25.1954 29.3337 26.6681 29.3337C28.1409 29.3337 29.3348 28.1398 29.3348 26.667V13.3337ZM8.00146 24.0003C8.00146 22.5276 6.80756 21.3337 5.3348 21.3337C3.86204 21.3337 2.66813 22.5276 2.66813 24.0003L2.66813 26.667C2.66813 28.1398 3.86204 29.3337 5.3348 29.3337C6.80756 29.3337 8.00146 28.1398 8.00146 26.667V24.0003ZM16.0015 16.0003C17.4742 16.0003 18.6681 17.1942 18.6681 18.667V26.667C18.6681 28.1398 17.4742 29.3337 16.0015 29.3337C14.5287 29.3337 13.3348 28.1398 13.3348 26.667V18.667C13.3348 17.1942 14.5287 16.0003 16.0015 16.0003Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardFilesIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.6667 2.66699C20.6487 2.66699 22.294 4.10852 22.6114 6.00033L14.6667 6.00032C10.6166 6.00032 7.33334 9.28357 7.33334 13.3337L7.33333 23.945C5.44153 23.6276 4 21.9823 4 20.0003L4 6.66699C4 4.45785 5.79086 2.66699 8 2.66699L18.6667 2.66699ZM28 19.6768C28 19.8983 27.9816 20.118 27.9457 20.3337H25.3334C21.8356 20.3337 19 23.1692 19 26.667V29.2794C18.7843 29.3153 18.5647 29.3337 18.3432 29.3337L13.3334 29.3337C11.1242 29.3337 9.33335 27.5428 9.33335 25.3337L9.33335 12.0003C9.33335 9.7912 11.1242 8.00034 13.3334 8.00034L24 8.00034C26.2092 8.00034 28 9.7912 28 12.0003L28 19.6768ZM21.1716 28.1621C21.1158 28.2178 21.0586 28.2718 21 28.3238V26.667C21 24.2738 22.9401 22.3337 25.3334 22.3337H26.9902C26.9381 22.3923 26.8842 22.4495 26.8284 22.5052L21.1716 28.1621Z" fill="#7DBA28"/>
    </svg>
)
export const DashboardCompassIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M16 1.66699C16.5523 1.667 17 2.11471 17 2.667L17 5.47924C18.8107 5.9148 20.1532 7.50629 20.1532 9.40291C20.1532 10.1592 19.9397 10.867 19.5682 11.4723C18.8524 12.6385 17.5501 13.4244 16.0576 13.4441L16.0001 13.4445L15.9424 13.4441C14.45 13.4243 13.1477 12.6385 12.4319 11.4723C12.0605 10.867 11.847 10.1592 11.847 9.40291C11.847 7.50633 13.1894 5.91487 15 5.47928L15 2.66699C15 2.1147 15.4478 1.66699 16 1.66699ZM11.3274 13.334L7.96573 19.0003H4C3.44772 19.0003 3 19.448 3 20.0003C3 20.5526 3.44772 21.0003 4 21.0003H6.77917L4.74188 24.4343C4.14281 25.444 3.89645 26.6157 4.03976 27.7733L4.15214 28.681C4.19277 29.0091 4.53498 29.2081 4.84028 29.0812L5.71821 28.7163C6.82003 28.2583 7.73948 27.4648 8.33855 26.4551L11.5747 21.0003H20.4253L23.6614 26.4551C24.2605 27.4648 25.18 28.2583 26.2818 28.7163L27.1597 29.0812C27.465 29.2081 27.8072 29.0091 27.8479 28.681L27.9602 27.7733C28.1036 26.6157 27.8572 25.444 27.2581 24.4343L25.2208 21.0003H28C28.5523 21.0003 29 20.5526 29 20.0003C29 19.448 28.5523 19.0003 28 19.0003H24.0343L20.6726 13.3341C19.7624 14.3763 18.4997 15.1057 17.0745 15.3525L19.2387 19.0003H12.7613L14.9255 15.3525C13.5003 15.1057 12.2376 14.3762 11.3274 13.334Z" fill="#7DBA28"/>
    </svg>
)
export const SearchIcon16 = (props) => (
    <svg
        width={16}
        height={16}
        opacity="0.7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g
            clipPath="url(#a)"
            stroke="#2A353D"
            strokeWidth={1.5}
            strokeLinejoin="round"
        >
            <path d="m11.666 11.667 3 3" strokeLinecap="round" />
            <path d="M13.332 7.333a6 6 0 1 0-12 0 6 6 0 0 0 12 0Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)
export const StatusFilterIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd" d="M2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.0825 2.75 21.2077 6.84923 21.2497 11.9218C21.2531 12.336 21.5917 12.669 22.0059 12.6655C22.4201 12.6621 22.7531 12.3236 22.7496 11.9094C22.7009 6.01395 17.9068 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9068 6.01395 22.7009 11.9094 22.7496C12.3236 22.7531 12.6621 22.4201 12.6655 22.0059C12.669 21.5917 12.336 21.2531 11.9218 21.2497C6.84923 21.2077 2.75 17.0825 2.75 12ZM12 7.75C9.65279 7.75 7.75 9.65279 7.75 12C7.75 13.7835 8.84882 15.3122 10.4092 15.9425C10.7933 16.0976 10.9789 16.5347 10.8237 16.9188C10.6686 17.3029 10.2315 17.4884 9.84739 17.3333C7.7395 16.4818 6.25 14.4157 6.25 12C6.25 8.82436 8.82436 6.25 12 6.25C14.4157 6.25 16.4818 7.7395 17.3333 9.84739C17.4884 10.2315 17.3029 10.6686 16.9188 10.8237C16.5347 10.9789 16.0976 10.7933 15.9425 10.4092C15.3122 8.84882 13.7835 7.75 12 7.75ZM14.6699 21.2614L12.0573 13.4235C11.7758 12.5792 12.5792 11.7758 13.4235 12.0573L21.2614 14.6699C22.2462 14.9982 22.2462 16.3911 21.2614 16.7193L18.3672 17.6841C18.0447 17.7916 17.7916 18.0447 17.6841 18.3672L16.7193 21.2614C16.3911 22.2462 14.9982 22.2462 14.6699 21.2614Z"
            fill="#77787A"/>
    </svg>
)

export const UploadImg = (props) => (
    <svg
        width={64}
        height={46}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M32 0c4.761 0 9.53 1.8 13.163 5.412a18.39 18.39 0 0 1 5.325 10.94C58.07 17.036 64 23.367 64 31.085c0 8.175-6.664 14.802-14.884 14.802H12.651C5.642 45.887 0 40.275 0 33.305c0-6.97 5.642-12.582 12.651-12.582h.884a18.444 18.444 0 0 1 5.325-15.31C22.493 1.798 27.24 0 32 0Zm0 15.542c-.395-.001-.672.073-1 .37l-8.186 7.402c-.582.52-.69 1.533-.116 2.104.552.55 1.538.617 2.116.093l5.698-5.158v15.912c0 .818.666 1.48 1.488 1.48s1.488-.662 1.488-1.48V20.353l5.698 5.158c.578.524 1.591.484 2.116-.093.525-.577.496-1.575-.116-2.104L33 15.912c-.213-.193-.602-.362-1-.37Z"
            fill="#82B432"
        />
    </svg>
)



export const BurgerIcon = () => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 1H11M1 5H11M1 9H11"
            stroke="#83C805"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)


export const HeaderNotificationIcon = (props) => (
    <svg
        width={30}
        height={30}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m25.238 17.575-1.412-2.35c-.313-.512-.588-1.5-.588-2.1v-2.338c0-4.537-3.688-8.225-8.213-8.225-4.537.013-8.224 3.688-8.224 8.226v2.325c0 .6-.276 1.587-.575 2.1l-1.413 2.35c-.537.912-.662 1.95-.325 2.85.337.912 1.1 1.637 2.1 1.962 1.35.45 2.712.775 4.1 1.012.137.026.275.038.412.063.175.025.363.05.55.075.325.05.65.088.988.113a25.234 25.234 0 0 0 4.737 0c.288-.026.576-.05.85-.088.226-.025.45-.05.675-.088.138-.012.276-.037.413-.062 1.4-.225 2.788-.575 4.138-1.025A3.312 3.312 0 0 0 25.5 20.4c.35-.938.25-1.962-.263-2.825Zm-9.3-5.075a.95.95 0 1 1-1.9 0V8.625a.95.95 0 1 1 1.9 0V12.5ZM18.54 25.012a3.768 3.768 0 0 1-3.538 2.488c-.988 0-1.963-.4-2.65-1.113-.4-.375-.7-.875-.875-1.387.162.025.325.038.5.063.287.037.587.075.887.1.713.062 1.438.1 2.163.1.712 0 1.425-.038 2.125-.1.262-.026.525-.038.775-.076l.612-.075Z"
            fill="#C4C4C4"
        />
    </svg>
)


export const MessageIcon = (props) => (
    <svg
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 3h2a9 9 0 1 1 0 18H6a4 4 0 0 1-4-4v-5a9 9 0 0 1 9-9Zm1 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            fill="#A2A3A4"
        />
    </svg>
)

export const HugeNotificationIcon = (props) => (
    <svg
        width={100}
        height={100}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M74.073 75H25.93c-7.619 0-11.967-7.663-7.396-13.033 2.023-2.377 3.27-5.197 3.606-8.154l1.863-16.417c1.005-8.852 7.613-16.116 16.54-19.173v-.432a9.458 9.458 0 0 1 9.458-9.458 9.458 9.458 0 0 1 9.458 9.458v.432C68.386 21.28 74.995 28.544 76 37.396l1.864 16.417c.335 2.957 1.582 5.777 3.606 8.154C86.039 67.337 81.69 75 74.073 75Zm-11.688 8.63c-1.906 4.7-6.731 8.036-12.384 8.036-5.652 0-10.478-3.336-12.383-8.035a1.642 1.642 0 0 1-.117-.618c0-.974.79-1.763 1.764-1.763h21.473c.974 0 1.763.79 1.763 1.763 0 .212-.036.422-.116.618Z"
            fill="#B2B2B2"
        />
    </svg>
)




